<template>
  <div class="wrap">
    <div class="editHead">
      <router-link class="logo" to="/">
      </router-link>
      <p class="modelname">{{modelName}}</p>
      <div class="actions">
        <el-button size="medium" type="primary" @click="saveOptions">save</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button size="medium" type="success" @click="goWeb('preview')">preview</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button size="medium" type="" @click="exitEdit">exit</el-button>
      </div>
    </div>
    <div class="editPanel" ref="editPanel">
      <div class="editPanelTop">
          <el-tooltip class="item" effect="light" content="基础设置" placement="top">
            <i :class="['el-icon-setting',activePanelNum==0?'active':'']" @click="changePanel(0)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="灯光" placement="top">
            <i :class="['el-icon-sunny',activePanelNum==1?'active':'']" @click="changePanel(1)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="材质" placement="top">
            <i :class="['el-icon-picture-outline',activePanelNum==2?'active':'']" @click="changePanel(2)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="特效" placement="top">
            <i :class="['el-icon-magic-stick',activePanelNum==3?'active':'']" @click="changePanel(3)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="热点" placement="top">
            <i :class="['el-icon-location-outline',activePanelNum==4?'active':'']" @click="changePanel(4)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="动作" placement="top">
            <i :class="['el-icon-video-play',activePanelNum==5?'active':'']" @click="changePanel(5)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="AR" placement="top">
            <i :class="['el-icon-view',activePanelNum==6?'active':'']" @click="changePanel(6)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="其它" placement="top">
            <i :class="['el-icon-help',activePanelNum==7?'active':'']" @click="changePanel(7)"></i>
          </el-tooltip>
      </div>
      <div v-if="activePanelNum==0" class="editPanelWrap basic">
        <el-scrollbar style="height:100%;">
          <el-collapse>
            <el-collapse-item title="坐标设置" name="1">
              <div class="item">
                    <p>POSITION:</p>
                    <div>
                      <span class="label">X:</span>
                      <el-input v-model="modelInfo.posX" @change="posSelectObj('position','x',modelInfo.posX)"></el-input>
                    </div>
                    <div>
                      <span class="label">Y:</span>
                      <el-input v-model="modelInfo.posY" @change="posSelectObj('position','y',modelInfo.posY)"></el-input>
                    </div>
                    <div>
                      <span class="label">Z:</span>
                      <el-input v-model="modelInfo.posZ" @change="posSelectObj('position','z',modelInfo.posZ)"></el-input>
                    </div>
                    <el-divider></el-divider>
                    <p>ROTATION:</p>
                    <div>
                      <span class="label">X:</span>
                      <el-input v-model="modelInfo.rotationX" @change="posSelectObj('rotation','x',modelInfo.rotationX)"></el-input>
                    </div>
                    <div>
                      <span class="label">Y:</span>
                      <el-input v-model="modelInfo.rotationY" @change="posSelectObj('rotation','y',modelInfo.rotationY)"></el-input>
                    </div>
                    <div>
                      <span class="label">Z:</span>
                      <el-input v-model="modelInfo.rotationZ" @change="posSelectObj('rotation','z',modelInfo.rotationZ)"></el-input>
                    </div>
                    <el-divider></el-divider>
                    <p>SCALE:</p>
                    <div>
                      <span class="label">X:</span>
                      <el-input v-model="modelInfo.scaleX" @change="posSelectObj('scale','x',modelInfo.scaleX)"></el-input>
                    </div>
                    <div>
                      <span class="label">Y:</span>
                      <el-input v-model="modelInfo.scaleY" @change="posSelectObj('scale','y',modelInfo.scaleY)"></el-input>
                    </div>
                    <div>
                      <span class="label">Z:</span>
                      <el-input v-model="modelInfo.scaleZ" @change="posSelectObj('scale','z',modelInfo.scaleZ)"></el-input>
                    </div>
              </div>
            </el-collapse-item>           
            <el-collapse-item title="相机设置" name="2">
              <div class="item">
                    <p>POSITION:</p>
                    <div>
                      <span class="label">X:</span>
                      <el-input v-model="cPosX" @change="posCamera('position','x',cPosX)"></el-input>
                    </div>
                    <div>
                      <span class="label">Y:</span>
                      <el-input v-model="cPosY" @change="posCamera('position','y',cPosY)"></el-input>
                    </div>
                    <div>
                      <span class="label">Z:</span>
                      <el-input v-model="cPosZ" @change="posCamera('position','z',cPosZ)"></el-input>
                    </div>
                    <el-divider></el-divider>
                    <div>
                      <span class="label">FOV:</span>
                      <el-input v-model="cFov" @change="posCamera('fov','',cFov)"></el-input>
                    </div>
                    <div>
                      <span class="label">NEAR:</span>
                      <el-input v-model="cNear" @change="posCamera('near','',cNear)"></el-input>
                    </div>
                    <div>
                      <span class="label">FAR:</span>
                      <el-input v-model="cFar" @change="posCamera('far','',cFar)"></el-input>
                    </div>
              </div>
              <div class="item">
                <el-button size="medium" @click="saveCamera()">保存相机状态</el-button>
              </div>
            </el-collapse-item>
            <el-collapse-item name="3">
              <template slot="title">
                背景选择
                <span :class="['state','onCloseBtn',bgOn?'active':'']" @click.stop="changeOnClose('bgOn')">
                  <span v-if="bgOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!bgOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                  <el-tabs stretch type="border-card" v-model="activeBgName" @tab-click="tabHandleClick">
                    <el-tab-pane label="COLOR" name="color">
                      <el-color-picker v-model="bgcolor" @change="changeBg('color',bgcolor,-1)"></el-color-picker>
                    </el-tab-pane>
                    <el-tab-pane label="IMAGE" name="image">
                      <ul>
                        <li :class="['bg', bgActiveNum==0?'active':'']" @click="changeBg('image','images/bgs/1.jpeg',0)">
                          <img src="images/bgs/1.jpeg" alt="">
                          <span>bg1</span>
                        </li>
                        <li :class="['bg', bgActiveNum==1?'active':'']" @click="changeBg('image','images/bgs/2.jpeg',1)">
                          <img src="images/bgs/2.jpeg" alt="">
                          <span>bg2</span>
                        </li>
                        <li :class="['bg', bgActiveNum==2?'active':'']" @click="changeBg('image','images/bgs/3.jpeg',2)">
                          <img src="images/bgs/3.jpeg" alt="">
                          <span>bg3</span>
                        </li>
                        <li :class="['bg', bgActiveNum==3?'active':'']" @click="changeBg('image','images/bgs/4.jpeg',3)">
                          <img src="images/bgs/4.jpeg" alt="">
                          <span>bg4</span>
                        </li>
                        <li :class="['bg', bgActiveNum==4?'active':'']" @click="changeBg('image','images/bgs/5.jpg',4)">
                          <img src="images/bgs/5.jpg" alt="">
                          <span>bg5</span>
                        </li>
                        <li :class="['bg', bgActiveNum==5?'active':'']" @click="changeBg('image','images/bgs/6.jpg',5)">
                          <img src="images/bgs/6.jpg" alt="">
                          <span>bg6</span>
                        </li>
                      </ul>
                    </el-tab-pane>
                  </el-tabs>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div v-if="activePanelNum==1" class="editPanelWrap lightWrap">
        <el-scrollbar style="height:100%;">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                添加灯光
                <!-- <span :class="['state','onCloseBtn',lightOn?'active':'']" @click.stop="changeOnClose('lightOn')">
                  <span v-if="lightOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!lightOn" class="off"><span class="border"></span>OFF</span>
                </span> -->
              </template>
              <div class="item">
                <el-button size="medium">加载默认灯光</el-button>
                <el-card class="box-card">
                  <div 
                  :class="['lightItem', lightItemActive==i?'active':'']" 
                  v-for="(item,i) in modelInfo.modelsLight"
                  :key="i" 
                  @click="changeLightItem(i,item)">
                    <span class="num">{{i+1}}:</span>
                    <span class="name">{{item.type}}</span>
                    <i class="el-icon-view"></i>
                  </div>
                  <!-- <div :class="['lightItem', lightItemActive==1?'active':'']" @click="changeLightItem(1)">
                    <span class="num">2:</span>
                    <span class="name">平行光</span>
                    <i class="el-icon-view"></i>
                  </div>
                  <div :class="['lightItem', lightItemActive==2?'active':'']" @click="changeLightItem(2)">
                    <span class="num">3:</span>
                    <span class="name">平行光</span>
                    <i class="el-icon-view"></i>
                  </div> -->
                </el-card>
                <el-card v-if="lightItemActive!=-1&&modelInfo.modelsLight.length>0" class="box-card lightProWrap">
                  <div slot="header" class="clearfix">
                    <span>灯光参数</span>
                  </div>
                  <el-tabs stretch type="border-card" v-model="modelInfo.modelsLight[lightItemActive].type" @tab-click="lightTypeHandleClick">
                    <el-tab-pane label="无" name="none">
                    </el-tab-pane>
                    <el-tab-pane label="环境光" name="AmbientLight">
                      <div class="lightPro ambient" >
                        <div class="color">
                          <span class="label">颜色:</span>
                          <el-color-picker v-model="modelInfo.modelsLight[lightItemActive].color" @change="changeLight('color',modelInfo.modelsLight[lightItemActive].color)"></el-color-picker>
                        </div>
                        <div class="intensity">
                          <span class="label">强度:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].intensity" @change="changeLight('intensity',modelInfo.modelsLight[lightItemActive].intensity)"></el-input>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="平行光" name="DirectionalLight">
                      <div class="lightPro dirLight" >
                        <div>
                          <p>POSITION:</p>
                          <div>
                            <span class="label">X:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posX"  @change="changeLight('position.x',modelInfo.modelsLight[lightItemActive].posX)"></el-input>
                          </div>
                          <div>
                            <span class="label">Y:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posY" @change="changeLight('position.y',modelInfo.modelsLight[lightItemActive].posY)"></el-input>
                          </div>
                          <div>
                            <span class="label">Z:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posZ" @change="changeLight('position.z',modelInfo.modelsLight[lightItemActive].posZ)"></el-input>
                          </div>
                        </div>
                        <el-divider></el-divider>
                        <div class="color">
                          <span class="label">颜色:</span>
                          <el-color-picker v-model="modelInfo.modelsLight[lightItemActive].color" @change="changeLight('color',modelInfo.modelsLight[lightItemActive].color)"></el-color-picker>
                        </div>
                        <div class="intensity">
                          <span class="label">强度:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].intensity" @change="changeLight('intensity',modelInfo.modelsLight[lightItemActive].intensity)"></el-input>
                        </div>
                        <div class="castShadow">
                          <span class="label">阴影:</span>
                          <span :class="['state','onCloseBtn',modelInfo.modelsLight[lightItemActive].castShadow?'active':'']" @click.stop="changeLight('castShadow','')">
                            <span v-if="modelInfo.modelsLight[lightItemActive].castShadow" class="on">ON<span class="border"></span></span>
                            <span v-if="!modelInfo.modelsLight[lightItemActive].castShadow" class="off"><span class="border"></span>OFF</span>
                          </span>
                        </div>
                        <div>
                          <span class="label">bias:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].bias" @click.stop="changeLight('bias',modelInfo.modelsLight[lightItemActive].bias)"></el-input>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="点光源" name="PointLight">
                      <div class="lightPro dirLight" >
                        <div>
                          <p>POSITION:</p>
                          <div>
                            <span class="label">X:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posX" @change="changeLight('position.x',modelInfo.modelsLight[lightItemActive].posX)"></el-input>
                          </div>
                          <div>
                            <span class="label">Y:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posY" @change="changeLight('position.y',modelInfo.modelsLight[lightItemActive].posY)"></el-input>
                          </div>
                          <div>
                            <span class="label">Z:</span>
                            <el-input v-model="modelInfo.modelsLight[lightItemActive].posZ" @change="changeLight('position.z',modelInfo.modelsLight[lightItemActive].posZ)"></el-input>
                          </div>
                        </div>
                        <el-divider></el-divider>
                        <div class="color">
                          <span class="label">颜色:</span>
                          <el-color-picker v-model="modelInfo.modelsLight[lightItemActive].color" @change="changeLight('color',modelInfo.modelsLight[lightItemActive].color)"></el-color-picker>
                        </div>
                        <div class="intensity">
                          <span class="label">强度:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].intensity" @change="changeLight('intensity',modelInfo.modelsLight[lightItemActive].intensity)"></el-input>
                        </div>
                        <div class="distance">
                          <span class="label">光照距离:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].distance" @change="changeLight('distance',modelInfo.modelsLight[lightItemActive].distance)"></el-input>
                        </div>
                        <div class="decay">
                          <span class="label">衰退值:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].decay" @change="changeLight('decay',modelInfo.modelsLight[lightItemActive].decay)"></el-input>
                        </div>
                        <div class="castShadow">
                          <span class="label">阴影:</span>
                          <span :class="['state','onCloseBtn',modelInfo.modelsLight[lightItemActive].castShadow?'active':'']" @click.stop="changeLight('castShadow','')">
                            <span v-if="modelInfo.modelsLight[lightItemActive].castShadow" class="on">ON<span class="border"></span></span>
                            <span v-if="!modelInfo.modelsLight[lightItemActive].castShadow" class="off"><span class="border"></span>OFF</span>
                          </span>
                        </div>
                        <div>
                          <span class="label">bias:</span>
                          <el-input v-model="modelInfo.modelsLight[lightItemActive].bias" @change="changeLight('bias',modelInfo.modelsLight[lightItemActive].bias)"></el-input>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </el-card>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div v-if="activePanelNum==2" class="editPanelWrap material">
        <el-scrollbar style="height:100%;">
          <div class="modelSelectWrap">
            <div class="label">物体选择:</div>
            <!-- <div :class="{'selectUp':true}" @click="modelSelectDownShow=!modelSelectDownShow">
              {{modelInfo.models[nowModelIndex].name}}
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div :class="{'selectDown':true}" v-if="modelSelectDownShow">
              <div :class="{'option':true,'active':i==nowModelIndex}" v-for="(item,i) in modelInfo.models" :key="i" @click="nowModelName=item.name;modelSelectDownShow=false;nowModelIndex=i">{{item.name}}</div>
            </div> -->
            <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
            <div class="item">
                <span class="label">是否隐藏选中状态:</span>
                <div class="stateWrap">
                   <span :class="['hideselectedstate','state','onCloseBtn',hideselectedstate?'active':'']" @click.stop="changeOnClose('hideselectedstate')">
                    <span v-if="hideselectedstate" class="on">ON<span class="border"></span></span>
                    <span v-if="!hideselectedstate" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
          </div>
          <div class="matStyleWrap">
            <div class="label">材质选择:</div>
            <div :class="{'selectUp':true}" @click="matStyleDownShow=!matStyleDownShow">
              {{nowmatStyle}}
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div :class="{'selectDown':true}" v-if="matStyleDownShow">
              <div :class="{'option':true,'active':item==nowmatStyle}" v-for="(item,i) in nowmatStyles" :key="i" @click="nowmatStyle=item;matStyleDownShow=false">{{item}}</div>
            </div>
          </div>
          <el-collapse>
            <el-collapse-item title="Color" name="1">
              <div class="item">
                <span class="label">颜色:</span>
                <el-color-picker v-model="modelInfo.models[nowModelIndex].color" @change="changeMatColor('color',modelInfo.models[nowModelIndex].color)"></el-color-picker>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Emissive" name="21">
              <div class="item">
                <span class="label">颜色:</span>
                <el-color-picker v-model="modelInfo.models[nowModelIndex].emissive" @change="changeMatColor('emissive',modelInfo.models[nowModelIndex].emissive)"></el-color-picker>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Roughness" name="2">
              <div class="item">
                <span class="label">粗造度:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].roughness" @change="changeMatAttrOut('roughness',modelInfo.models[nowModelIndex].roughness)"></el-input>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Metalness" name="3">
              <div class="item">
                <span class="label">金属度:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].metalness" @change="changeMatAttrOut('metalness',modelInfo.models[nowModelIndex].metalness)"></el-input>
              </div>
            </el-collapse-item>
            <el-collapse-item name="4">
              <template slot="title">
                Map:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].map.selected?'active':'']" @click.stop="changeMapUse('map')">
                  <span v-if="modelInfo.models[nowModelIndex].map.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].map.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">纹理贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'map')">
                  <img v-if="modelInfo.models[nowModelIndex].map.url" :src="'http://model.z2ww.com/'+modelInfo.models[nowModelIndex].map.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].map.flipY?'active':'']" @click.stop="changeFlipY('map')">
                    <span v-if="modelInfo.models[nowModelIndex].map.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].map.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
              <!-- <div class="item">
                <span class="label">mapping:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="mappingDownShow=!mappingDownShow">
                    {{mapping}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="mappingDownShow">
                    <div :class="{'option':true,'active':item==mapping}" v-for="(item,i) in mappings" :key="i" @click="mapping=item;mappingDownShow=false">{{item}}</div>
                  </div>
                </div>
              </div> -->
              <div class="item">
                <span class="label">magFilter:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="magFilterDownShow=!magFilterDownShow">
                    {{modelInfo.models[nowModelIndex].map.magFilter}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="magFilterDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].map.magFilter}" v-for="(item,i) in magFilters" :key="i"
                    @click="changeMatAttr('map','magFilter','magFilterDownShow',item)"
                    >{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item">
                <span class="label">minFilter:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="minFilterDownShow=!minFilterDownShow">
                    {{modelInfo.models[nowModelIndex].map.minFilter}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="minFilterDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].map.minFilter}" v-for="(item,i) in minFilters" :key="i" @click="changeMatAttr('map','minFilter','minFilterDownShow',item)">{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item">
                <span class="label">anisotropy:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].map.anisotropy" @change="changeAnisotropy('map')"></el-input>
              </div>
            </el-collapse-item>
            <el-collapse-item name="5">
              <template slot="title">
                Normalmap:
                <span :class="['normalmapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].normalMap.selected?'active':'']" @click.stop="changeMapUse('normalMap')">
                  <span v-if="modelInfo.models[nowModelIndex].normalMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].normalMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">法线贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'normalMap')">
                  <img v-if="modelInfo.models[nowModelIndex].normalMap.url" :src="'http://model.z2ww.com/'+modelInfo.models[nowModelIndex].normalMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">scale:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].normalMap.scale" @change="changeScale('normalMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].normalMap.flipY?'active':'']" @click.stop="changeFlipY('normalMap')">
                    <span v-if="modelInfo.models[nowModelIndex].normalMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].normalMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="6">
              <template slot="title">
                DisplaceMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].displacementMap.selected?'active':'']" @click.stop="changeMapUse('displacementMap')">
                  <span v-if="modelInfo.models[nowModelIndex].displacementMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].displacementMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">置换贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'displacementMap')">
                  <img v-if="modelInfo.models[nowModelIndex].displacementMap.url" :src="'http://model.z2ww.com/'+modelInfo.models[nowModelIndex].displacementMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">scale:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].displacementMap.scale" @change="changeScale('displacementMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">bias:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].displacementMap.bias"  @change="changeBias('displacementMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].displacementMap.flipY?'active':'']" @click.stop="changeFlipY('displacementMap')">
                    <span v-if="modelInfo.models[nowModelIndex].displacementMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].displacementMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="7">
              <template slot="title">
                RoughnessMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].roughnessMap.selected?'active':'']" @click.stop="changeMapUse('roughnessMap')">
                  <span v-if="modelInfo.models[nowModelIndex].roughnessMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].roughnessMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">粗糙度贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'roughnessMap')">
                  <img v-if="modelInfo.models[nowModelIndex].roughnessMap.url" :src="'http://model.z2ww.com/'+modelInfo.models[nowModelIndex].roughnessMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].roughnessMap.flipY?'active':'']" @click.stop="changeFlipY('roughnessMap')">
                    <span v-if="modelInfo.models[nowModelIndex].roughnessMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].roughnessMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="8">
              <template slot="title">
                MetalnessMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].metalnessMap.selected?'active':'']" @click.stop="changeMapUse('metalnessMap')">
                  <span v-if="modelInfo.models[nowModelIndex].metalnessMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].metalnessMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">金属度贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'metalnessMap')">
                  <img v-if="modelInfo.models[nowModelIndex].metalnessMap.url" :src="'http://model.z2ww.com/'+modelInfo.models[nowModelIndex].metalnessMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].metalnessMap.flipY?'active':'']" @click.stop="changeFlipY('metalnessMap')">
                    <span v-if="modelInfo.models[nowModelIndex].metalnessMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].metalnessMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="9">
              <template slot="title">
                LightMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].lightMap.selected?'active':'']" @click.stop="changeMapUse('lightMap')">
                  <span v-if="modelInfo.models[nowModelIndex].lightMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].lightMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">灯光贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'lightMap')">
                  <img v-if="modelInfo.models[nowModelIndex].lightMap.url" :src="modelInfo.models[nowModelIndex].lightMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">intensity:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].lightMap.intensity" @change="changeIntensity('lightMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].lightMap.flipY?'active':'']" @click.stop="changeFlipY('lightMap')">
                    <span v-if="modelInfo.models[nowModelIndex].lightMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].lightMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="10">
              <template slot="title">
                AoMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].aoMap.selected?'active':'']" @click.stop="changeMapUse('aoMap')">
                  <span v-if="modelInfo.models[nowModelIndex].aoMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].aoMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">AO贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'aoMap')">
                  <img v-if="modelInfo.models[nowModelIndex].aoMap.url" :src="modelInfo.models[nowModelIndex].aoMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">intensity:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].aoMap.intensity" @change="changeIntensity('aoMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].aoMap.flipY?'active':'']" @click.stop="changeFlipY('aoMap')">
                    <span v-if="modelInfo.models[nowModelIndex].aoMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].aoMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="11">
              <template slot="title">
                EnvMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].envMap.selected?'active':'']" @click.stop="changeMapUse('envMap')">
                  <span v-if="modelInfo.models[nowModelIndex].envMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].envMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">环境贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'envMap')">
                  <img v-if="modelInfo.models[nowModelIndex].envMap.url" :src="modelInfo.models[nowModelIndex].envMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">intensity:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].envMap.intensity" @change="changeIntensity('envMap')"></el-input>
              </div>
              <!-- <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].envMap.flipY?'active':'']" @click.stop="changeFlipY('envMap')">
                    <span v-if="modelInfo.models[nowModelIndex].envMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].envMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div> -->
            </el-collapse-item>
            <el-collapse-item name="12">
              <template slot="title">
                EmissiveMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].emissiveMap.selected?'active':'']" @click.stop="changeMapUse('emissiveMap')">
                  <span v-if="modelInfo.models[nowModelIndex].emissiveMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].emissiveMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">自发光贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'emissiveMap')">
                  <img v-if="modelInfo.models[nowModelIndex].emissiveMap.url" :src="modelInfo.models[nowModelIndex].emissiveMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">intensity:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].emissiveMap.intensity" @change="changeIntensity('emissiveMap')"></el-input>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].emissiveMap.flipY?'active':'']" @click.stop="changeFlipY('emissiveMap')">
                    <span v-if="modelInfo.models[nowModelIndex].emissiveMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].emissiveMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="13">
              <template slot="title">
                AlphaMap:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].alphaMap.selected?'active':'']" @click.stop="changeMapUse('alphaMap')">
                  <span v-if="modelInfo.models[nowModelIndex].alphaMap.selected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].alphaMap.selected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">通道贴图:</span>
                <el-upload
                  class="avatar-uploader"
                  action="/api/APFAPI/UploadFile"
                  :show-file-list="false"
                  :on-success="(res,file)=>handleUploadSuccess(res,file,'alphaMap')">
                  <img v-if="modelInfo.models[nowModelIndex].alphaMap.url" :src="modelInfo.models[nowModelIndex].alphaMap.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="item">
                <span class="label">flipY:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].alphaMap.flipY?'active':'']" @click.stop="changeFlipY('alphaMap')">
                    <span v-if="modelInfo.models[nowModelIndex].alphaMap.flipY" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].alphaMap.flipY" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="RefractionRatio" name="14">
              <div class="item">
                <span class="label">折射率:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].refractionRatio"  @change="changeMatAttrOut('refractionRatio',modelInfo.models[nowModelIndex].refractionRatio)"></el-input>
              </div>
            </el-collapse-item>
            <el-collapse-item name="15">
              <template slot="title">
                Wireframe:
                <span :class="['mapstate','state','onCloseBtn',modelInfo.models[nowModelIndex].wireframeSelected?'active':'']" @click.stop="changeWireframeUse('wireframe')">
                  <span v-if="modelInfo.models[nowModelIndex].wireframeSelected" class="on">ON<span class="border"></span></span>
                  <span v-if="!modelInfo.models[nowModelIndex].wireframeSelected" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <span class="label">Linecap:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="linecapDownShow=!linecapDownShow">
                    {{modelInfo.models[nowModelIndex].wireframeLinecap}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="linecapDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].wireframeLinecap}" v-for="(item,i) in linecaps" :key="i" @click="
                      modelInfo.models[nowModelIndex].wireframeLinecap=item;linecapDownShow=false;changeWireframe('wireframe')
                    ">{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item">
                <span class="label">Linejoin:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="linejoinDownShow=!linejoinDownShow">
                    {{modelInfo.models[nowModelIndex].wireframeLinejoin}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="linejoinDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].wireframeLinejoin}" v-for="(item,i) in linejoins" :key="i" @click="
                      modelInfo.models[nowModelIndex].wireframeLinejoin=item;linejoinDownShow=false;changeWireframe('wireframe')
                    ">{{item}}</div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Others" name="16" >
              <div class="item">
                <span class="label">Side:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="sideDownShow=!sideDownShow">
                    {{modelInfo.models[nowModelIndex].side}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="sideDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].side}" v-for="(item,i) in sides" :key="i" @click="
                    modelInfo.models[nowModelIndex].side=item;sideDownShow=false;changeSide()
                    ">{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item">
                <span class="label">Blending:</span>
                <div class="selectWrap">
                  <div :class="{'selectUp':true}" @click="blendingDownShow=!blendingDownShow">
                    {{modelInfo.models[nowModelIndex].blending}}
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div :class="{'selectDown':true}" v-if="blendingDownShow">
                    <div :class="{'option':true,'active':item==modelInfo.models[nowModelIndex].blending}" v-for="(item,i) in blendings" :key="i" @click="
                    modelInfo.models[nowModelIndex].blending=item;blendingDownShow=false;changeBlending()"
                    >{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item">
                <span class="label">Transparent:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].transparent?'active':'']" @click.stop="
                   modelInfo.models[nowModelIndex].transparent=!modelInfo.models[nowModelIndex].transparent;
                   changeMatAttrOut('transparent',modelInfo.models[nowModelIndex].transparent)
                   ">
                    <span v-if="modelInfo.models[nowModelIndex].transparent" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].transparent" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
              <div class="item">
                <span class="label">Opacity:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].opacity" @change="changeMatAttrOut('opacity',modelInfo.models[nowModelIndex].opacity)"></el-input>
              </div>
              <div class="item">
                <span class="label">AlphaTest:</span>
                <el-input v-model="modelInfo.models[nowModelIndex].alphaTest" @change="changeMatAttrOut('alphaTest',modelInfo.models[nowModelIndex].alphaTest)"></el-input>
              </div>
              <div class="item">
                <span class="label">Fog:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].fog?'active':'']" @click.stop="
                   modelInfo.models[nowModelIndex].fog=!modelInfo.models[nowModelIndex].fog;
                   changeMatAttrOut('fog',modelInfo.models[nowModelIndex].fog)
                   ">
                    <span v-if="modelInfo.models[nowModelIndex].fog" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].fog" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
              <div class="item">
                <span class="label">DepthWrite:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].depthWrite?'active':'']" @click.stop="
                   modelInfo.models[nowModelIndex].depthWrite=!modelInfo.models[nowModelIndex].depthWrite;
                   changeMatAttrOut('depthWrite',modelInfo.models[nowModelIndex].depthWrite)
                   ">
                    <span v-if="modelInfo.models[nowModelIndex].depthWrite" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].depthWrite" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
              <div class="item">
                <span class="label">DepthTest:</span>
                <div class="stateWrap">
                   <span :class="['mapflipYstate','state','onCloseBtn',modelInfo.models[nowModelIndex].depthTest?'active':'']" @click.stop="
                   modelInfo.models[nowModelIndex].depthTest=!modelInfo.models[nowModelIndex].depthTest;
                  changeMatAttrOut('depthTest',modelInfo.models[nowModelIndex].depthTest)
                   ">
                    <span v-if="modelInfo.models[nowModelIndex].depthTest" class="on">ON<span class="border"></span></span>
                    <span v-if="!modelInfo.models[nowModelIndex].depthTest" class="off"><span class="border"></span>OFF</span>
                  </span>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div v-if="activePanelNum==3" class="editPanelWrap postprocessing">
        <el-scrollbar style="height:100%;">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                PostProcessing:
                <span :class="['mapstate','state','onCloseBtn',postprocessingOn?'active':'']" @click.stop="changeOnClose('postprocessingOn')">
                  <span v-if="postprocessingOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!postprocessingOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div v-if="activePanelNum==4" class="editPanelWrap hotpoint">
        <el-card class="box-card tip">
          <div slot="header" class="clearfix">
            <span>提示信息:</span>
          </div>
          <div class="item">
              <i class="el-icon-location-outline"></i>点击模型添加热点</div>
        </el-card>
        <el-card v-if="hotPoints.length>0" class="box-card hotpointsWrap">
          <el-scrollbar style="height:100%;">
          <div 
          :class="['hotPointItem', hotPointItemActive==i?'active':'']" 
          v-for="(item,i) in hotPoints" 
          :key="i" 
          @click="changeHotItem(i,item)">
            <span class="num">{{i+1}}:</span>
            <span class="name">{{item.title}}</span>
            <!-- <el-tooltip class="item" effect="dark" content="保存当前相机视角" placement="top"> -->
              <i class="el-icon-camera" @click.stop="saveCameraToHotPiont(i)"></i>
            <!-- </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除当前热点" placement="top"> -->
              <i class="el-icon-delete" @click.stop="deleteHotPiont(i)"></i>
             <!-- </el-tooltip>  -->
          </div>
          </el-scrollbar>
        </el-card>
        <el-card v-if="hotPoints.length>0&&hotPointItemActive>=0" class="box-card hotInfosWrap">
          <div slot="header" class="clearfix">
            <span>热点信息</span>
          </div>

          <div class="item hotTypeWrap">
            <span class="label">热点类型:</span>
            <div class="selectWrap">
              <div :class="{'selectUp':true}" @click="hotTypeDownShow=!hotTypeDownShow">
                {{hotTypes[hotPoints[hotPointItemActive].type-1]}}
                <i class="el-icon-caret-bottom"></i>
              </div>
              <div :class="{'selectDown':true}" v-if="hotTypeDownShow">
                <div :class="{'option':true,'active':item==hotTypes[hotPoints[hotPointItemActive].type-1]}" v-for="(item,i) in hotTypes" :key="i" @click="hotPoints[hotPointItemActive].type=(i+1);hotTypeDownShow=false">{{item}}</div>
              </div>
            </div>
          </div>
          <div class="item">
            <span class="label">标题:</span>
            <el-input v-model="hotPoints[hotPointItemActive].title"></el-input>
          </div>
          <div class="item" v-if="hotPoints[hotPointItemActive].type==1">
            <span class="label">内容:</span>
            <el-input type="textarea" :rows="4" v-model="hotPoints[hotPointItemActive].hotContent"></el-input>
          </div>
          <div class="item" v-if="hotPoints[hotPointItemActive].type==2">
            <span class="label">超链地址:</span>
            <el-input type="textarea" :rows="4" v-model="hotPoints[hotPointItemActive].hotContent"></el-input>
          </div>
          <div class="item" v-if="hotPoints[hotPointItemActive].type==3">
            <span class="label">关联图片:</span>
            <el-input type="textarea" :rows="4" disabled v-model="hotPoints[hotPointItemActive].hotContent"></el-input>
            <el-button class="uploadBtn" icon="el-icon-upload" @click="$refs.imageInput.click()"></el-button>
            <input type="file"  ref="imageInput" @change="uploadHotPointFile('image')" accept=".jpg,.png,.jpeg" style="display:none">
          </div>
          <div class="item" v-if="hotPoints[hotPointItemActive].type==4">
            <span class="label">关联视频:</span>
            <el-input type="textarea" :rows="4" disabled v-model="hotPoints[hotPointItemActive].hotContent"></el-input>
            <el-button class="uploadBtn" icon="el-icon-upload" @click="$refs.videoInput.click()"></el-button>
            <input type="file"  ref="videoInput" @change="uploadHotPointFile('video')" accept=".mp4" style="display:none">
          </div>
          <div class="item" v-if="hotPoints[hotPointItemActive].type==5">
            <span class="label">关联语音:</span>
            <el-input type="textarea" :rows="4" disabled v-model="hotPoints[hotPointItemActive].hotContent"></el-input>
            <el-button class="uploadBtn" icon="el-icon-upload" @click="$refs.audioInput.click()"></el-button>
            <input type="file"  ref="audioInput" @change="uploadHotPointFile('audio')" accept=".mp3" style="display:none">
          </div>
        </el-card>
      </div>
      
      <div v-if="activePanelNum==5" class="editPanelWrap animateEdit">
        <el-scrollbar style="height:100%;">
          <el-collapse>
            <el-collapse-item class="bgm" name="1">
              <template slot="title">
                动作1:
                <span :class="['mapstate','state','onCloseBtn',bgmOn?'active':'']" @click.stop="changeOnClose('bgmOn')">
                  <span v-if="bgmOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!bgmOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <el-button size="medium"  @click="$refs.bgmInput.click()">添加背景音乐</el-button>
                <input type="file"  ref="bgmInput" @change="uploadBGM('bgm')" accept=".mp3" style="display:none">
              </div>
              <el-card class="box-card" v-for="(item,i) in bgms" :key="i">
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <i class="el-icon-delete" @click.stop="deletebgm(i)"></i>
                </div>
                <div class="item">
                  <span class="label">是否循环播放:</span>
                  <div class="stateWrap">
                    <span :class="['mapflipYstate','state','onCloseBtn',item.loop?'active':'']" @click.stop="item.loop=!item.loop">
                      <span v-if="item.loop" class="on">ON<span class="border"></span></span>
                      <span v-if="!item.loop" class="off"><span class="border"></span>OFF</span>
                    </span>
                  </div>
                </div>
                <div class="item">
                  <audio :ref="'audio'+i" :src="'http://model.z2ww.com'+item.url"></audio>
                  <i class="el-icon-video-play" v-if="!audioIsPlaying" @click="playAudio(i)"></i>
                  <i class="el-icon-video-pause"  v-if="audioIsPlaying" @click="pauseAudio(i)"></i>
                  <el-slider v-model="item.volume" @change="changeVolume(i)"></el-slider>
                </div>
              </el-card>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
      <div v-if="activePanelNum==7" class="editPanelWrap others">
        <el-scrollbar style="height:100%;">
          <el-collapse>
            <el-collapse-item class="bgm" name="1">
              <template slot="title">
                bgm:
                <span :class="['mapstate','state','onCloseBtn',bgmOn?'active':'']" @click.stop="changeOnClose('bgmOn')">
                  <span v-if="bgmOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!bgmOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <el-button size="medium"  @click="$refs.bgmInput.click()">添加背景音乐</el-button>
                <input type="file"  ref="bgmInput" @change="uploadBGM('bgm')" accept=".mp3" style="display:none">
              </div>
              <el-card class="box-card" v-for="(item,i) in bgms" :key="i">
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <i class="el-icon-delete" @click.stop="deletebgm(i)"></i>
                </div>
                <div class="item">
                  <span class="label">是否循环播放:</span>
                  <div class="stateWrap">
                    <span :class="['mapflipYstate','state','onCloseBtn',item.loop?'active':'']" @click.stop="item.loop=!item.loop">
                      <span v-if="item.loop" class="on">ON<span class="border"></span></span>
                      <span v-if="!item.loop" class="off"><span class="border"></span>OFF</span>
                    </span>
                  </div>
                </div>
                <div class="item">
                  <audio :ref="'audio'+i" :src="'http://model.z2ww.com'+item.url"></audio>
                  <i class="el-icon-video-play" v-if="!audioIsPlaying" @click="playAudio(i)"></i>
                  <i class="el-icon-video-pause"  v-if="audioIsPlaying" @click="pauseAudio(i)"></i>
                  <el-slider v-model="item.volume" @change="changeVolume(i)"></el-slider>
                </div>
              </el-card>
            </el-collapse-item>
            <el-collapse-item class="logo" name="2">
              <template slot="title">
                logo:
                <span :class="['mapstate','state','onCloseBtn',logoOn?'active':'']" @click.stop="changeOnClose('logoOn')">
                  <span v-if="logoOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!logoOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                <el-button size="medium"  @click="$refs.logoInput.click()">添加LOGO</el-button>
                <input type="file"  ref="logoInput" @change="uploadLogo('logo')" accept=".jpg,.png,.jpeg" style="display:none">
              </div>
              <el-card class="box-card" v-for="(item,i) in logos" :key="i">
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <i class="el-icon-delete" @click.stop="deletelogo(i)"></i>
                </div>
                <div class="item">
                  <img :src="'http://model.z2ww.com'+item.url" alt="">
                </div>
                <div class="item">
                  <span class="label">位置选择:</span>
                  <div class="selectWrap">
                    <div :class="{'selectUp':true}" @click="posDownShow=!posDownShow">
                      {{item.pos}}
                      <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div :class="{'selectDown':true}" v-if="posDownShow">
                      <div :class="{'option':true,'active':itemc==item.pos}" v-for="(itemc,ic) in logoPoses" :key="ic" @click="item.pos=itemc;posDownShow=false,changeLogoPos(item.pos)">{{itemc}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-collapse-item>
            <el-collapse-item class="autoRotate" name="3">
              <template slot="title">
                自转:
                <span :class="['mapstate','state','onCloseBtn',autoRotateOn?'active':'']" @click.stop="changeOnClose('autoRotateOn')">
                  <span v-if="autoRotateOn" class="on">ON<span class="border"></span></span>
                  <span v-if="!autoRotateOn" class="off"><span class="border"></span>OFF</span>
                </span>
              </template>
              <div class="item">
                  <div>控制模型是否自动旋转，如果您需要模型自动旋转，请打开此项。</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
    </div>
    <div class="editView">
      <img class="logo" v-if="activePanelNum==7&&logos.length>0&&logoOn" :style="logoStyle" :src="'http://model.z2ww.com'+logos[logoActiveNum].url" alt="" srcset="">
      <div ref="webgl" class="webgl" :style="{'background-color':bgOn?bgcolor:'','background-image':bgOn?bgActiveImage:''}"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import https from '@/https.js'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import zcfCommon from '../../public/com/zcf_common'
let vm=null
export default {
  components: {},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeData:[{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
      posDownShow:false,
      logoPoses:[
        'left top',
        'mid top',
        // 'right top',
        'left mid',
        // 'mid mid',
        'right mid',
        // 'left bottom',
        // 'mid bottom',
        'right bottom'
      ],
      logoStyle:'',
      logoOn:false,
      logos:[
      ],
      logoActiveNum:0,
      audioIsPlaying:false,
      bgms:[
      ],
      bgmActiveNum:0,
      bgmOn:false,
      hotTypeDownShow:false,
      hotType:'',
      hotTypes:[
        '文字',
        '超链接',
        '图片',
        '视频',
        '语音'
      ],
      fileList:[
        {name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
      ],
      cPosX:150,
      cPosY:150,
      cPosZ:150,
      cFov:60,
      cNear:0.01,
      cFar:10000,
      activeBgName:'color',
      bgActiveNum:0,
      bgActiveImage:'',
      bgcolor: '#000000',
      activePanelNum:0,
      bgOn:false,
      lightItemActive:0,
      lightOn:false,
      lightcolor:'#ffffff',
      lightPosX:100,
      lightPosY:100,
      lightPosZ:100,
      lightIntentsity:1.0,
      lightShadowOn:false,
      bias:0.005,
      activeLightType:'none',
      lightDistance:100,
      lightDecay:1,
      nowModelName:'',
      modelNames:[],
      modelSelectDownShow:false,
      nowmatStyle:'PBR',
      nowmatStyles:['PBR'],
      matStyleDownShow:false,
      matColor:'#ffffff',
      emissive:'#ffffff',
      roughness:0.5,
      metalness:0.5,
      map:null,
      mapOn:false,
      mapUrl:'',
      mappings:[
        'UVMapping',
        'CubeReflectionMapping',
        'CubeRefractionMapping',
        'EquirectangularReflectionMapping',
        'EquirectangularRefractionMapping',
        'CubeUVReflectionMapping',
        'CubeUVRefractionMapping',
      ],
      mapping:'UVMapping',
      mappingDownShow:false,
      magFilters:[
        'NearestFilter',
        'LinearFilter',
      ],
      magFilter:'LinearFilter',
      magFilterDownShow:false,
      minFilters:[
        'NearestFilter',
        'NearestMipmapNearestFilter',
        'NearestMipmapLinearFilter',
        'LinearFilter',
        'LinearMipmapNearestFilter',
        'LinearMipmapLinearFilter'
      ],
      minFilter:'LinearMipmapLinearFilter',
      minFilterDownShow:false,
      anisotropy:1,
      mapflipY:false,
      normalmap:null,
      normalmapOn:false,
      normalmapUrl:'',
      normalmapflipY:false,
      normalScale:1.0,
      displacemap:null,
      displacementBias:0,
      displacemapOn:false,
      displacemapUrl:'',
      displacemapflipY:false,
      displaceScale:1.0,
      roughnessmap:null,
      roughnessmapOn:false,
      roughnessmapUrl:'',
      roughnessmapflipY:false,
      metalnessmap:null,
      metalnessmapOn:false,
      metalnessmapUrl:'',
      metalnessmapflipY:false,
      lightmap:null,
      lightmapOn:false,
      lightmapUrl:'',
      lightmapflipY:false,
      lightMapIntensity:1.0,
      aomap:null,
      aomapOn:false,
      aomapUrl:'',
      aomapflipY:false,
      aomapIntensity:1.0,
      envmap:null,
      envmapOn:false,
      envmapUrl:'',
      envmapflipY:false,
      envmapIntensity:1.0,
      emissivemap:null,
      emissivemapOn:false,
      emissivemapUrl:'',
      emissivemapflipY:false,
      emissivemapIntensity:1.0,
      alphamap:null,
      alphamapOn:false,
      alphamapUrl:'',
      alphamapflipY:false,
      refractionRatio:0.98,
      wireframe:false,
      wireframeOn:false,
      linecaps:[
        'butt',
        'round',
        'square'
      ],
      linecap:'round',
      linecapDownShow:false,
      linejoins:[
        'round',
        'bevel',
        'miter'
      ],
      linejoin:'round',
      linejoinDownShow:false,
      sides:[
        'FrontSide',
        'BackSide',
        'DoubleSide'
      ],
      side:'FrontSide',
      sideDownShow:false,
      transparent:false,
      fog:false,
      depthTest:true,
      depthWrite:true,
      blendings:[
        'NoBlending',
        'NormalBlending',
        'AdditiveBlending',
        'SubtractiveBlending',
        'MultiplyBlending',
        'CustomBlending'
      ],
      blending:'NormalBlending',
      blendingDownShow:false,
      opacity:1.0,
      alphaTest:0,
      postprocessingOn:false,
      logText: '',
      snackbar: false,
      hasSelected: false,
      selectObj: null,
      modelID: '',
      sideTypes: {
        'Front': 'FrontSide',
        'Back': 'BackSide',
        'Double': 'DoubleSide'
      },
      modelInfo:{
        castShadow:false,
        icon:'',
        backGround:{
          type:'',
          color:'',
          url:'',
          activeNum:-2
        },
        backGroundShow:false,
        backMusic:{
        },
        backMusicShow:false,
        logo:{
        },
        logoShow:false,
        models:[],
        name:'',
        path:'',
        posX:0,
        posY:0,
        posZ:0,
        projectKey:null,
        projectName:'',
        receiveShadow:false,
        remark:null,
        rotationX:0,
        rotationY:0,
        rotationZ:0,
        scaleX:1,
        scaleY:1,
        scaleZ:1,
        sceneIntroduce:'',
        sceneType:'gltf',
        status:1,
        url:null,
        userName:'',
        camera:{
          fov:60,
          near:0.01,
          far:10000,
          posX:0,
          posY:0,
          posZ:2000,
          name:'camera'
        },
        modelsLight:[
          {
            name:'light1',
            type:'AmbientLight',
            color:'#ffffff',
            posX:0,
            posY:0,
            posZ:0,
            castShadow:false,
            bias:0,
            distance:0,
            decay :0,
            intensity:1
          },
          {
            name:'light2',
            type:'DirectionalLight',
            color:'#ffffff',
            intensity: 1,
            posX:10,
            posY:10,
            posZ:10,
            castShadow:false,
            bias:0,
            distance:0,
            decay :0
          },
          {
            name:'light3',
            type:'DirectionalLight',
            color:'#ffffff',
            intensity: 0.8,
            posX:-10,
            posY:0,
            posZ:0,
            castShadow:false,
            bias:0,
            distance:0,
            decay :0
          }
        ]
      },
      hideselectedstate:true,
      nowModelIndex:0,
      hotPointItemActive:0,
      hotPoints:[],
      modelName:'',
      autoRotateOn:false
    }
  },
  created() {
    vm = this;
    this.modelID = this.$route.query.id;
  },
  mounted () {
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.lightGroup = new THREE.Group()
    this.lightHelpGroup = new THREE.Group()
    this.pmremGenerator = null
    this.hotPointGroup = new THREE.Group()
    this.modelData = null
    this.selectObj = null
    this.cameraCanControl = true
    this.textrueLoader = new THREE.TextureLoader()
    this.init()
  },
  methods: {
    exitEdit(){
      this.$confirm('退出将不保存当前页面所有操作,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ path: "/admin/modellist" })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消添加'
        });          
      });
    },
    handleNodeClick(data){
      console.log(data)
      console.log(this.modelInfo.models)
      var index =this.getObjectIndexByID(data.id)
      console.log(index)
      if(index>=0){
        this.selectObj = this.scene.getObjectById(data.id)
        console.log(this.selectObj)
        this.selectionBox.visible = true
        this.selectionBox.setFromObject(this.selectObj)
        this.transformControls.attach(this.selectObj)
        this.hasSelected = true
        this.nowModelName=this.selectObj.name
        this.nowModelIndex = index
      }
    },
    changeLogoPos(str){
      switch (str) {
        case 'left top':
          this.logoStyle = 'left:20rem;top:3.4375rem;transform:translateX(0) translateY(0);'
          break;
        case 'mid top':
          console.log(this.containerW )
          console.log(this.$refs.editPanel.getBoundingClientRect().width )
          var left = this.containerW/2 + this.$refs.editPanel.getBoundingClientRect().width
          this.logoStyle = 'left:'+left+'px;top:3.4375rem;transform:translateX(-50%) translateY(0);'
          break;
        case 'left mid':
          this.logoStyle = 'left:20rem;top:50%;transform:translateX(0) translateY(-50%);'
          break;
        case 'right mid':
          this.logoStyle = 'left:100%;top:50%;transform:translateX(-100%) translateY(-50%);'
          break;
        case 'right bottom':
          this.logoStyle = 'left:100%;top:100%;transform:translateX(-100%) translateY(-100%);'
          break;
        default:
          break;
      }
    },
    deletelogo(num){
      this.$confirm('确定删除此条商标图片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.logos.splice(num,1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    deletebgm(num){
      this.$confirm('确定删除此条背景音乐?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.bgms.splice(num,1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    changeMatAttrOut(str,val){
      this.mesh.getObjectByName(this.nowModelName).material[str] = val
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeBlending(){
      this.mesh.getObjectByName(this.nowModelName).material.blending = THREE[this.modelInfo.models[this.nowModelIndex].blending]
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeSide(){
      this.mesh.getObjectByName(this.nowModelName).material.side = THREE[this.modelInfo.models[this.nowModelIndex].side]
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeMatColor(str,val){
      this.mesh.getObjectByName(this.nowModelName).material[str].set(val)
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeIntensity(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        switch(str){
          case 'aoMap':
            this.mesh.getObjectByName(this.nowModelName).material.aoMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'envMap':
            this.mesh.getObjectByName(this.nowModelName).material.envMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'lightMap':
            this.mesh.getObjectByName(this.nowModelName).material.lightMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'lightMap':
            this.mesh.getObjectByName(this.nowModelName).material.emissiveIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          default:
            break;
        }
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeAnisotropy(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material[str].anisotropy = this.modelInfo.models[this.nowModelIndex][str].anisotropy
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeBias(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material.displacementBias = this.modelInfo.models[this.nowModelIndex][str].bias
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeScale(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        switch(str){
          case 'normalMap':
            this.mesh.getObjectByName(this.nowModelName).material.normalScale = new THREE.Vector2(
              this.modelInfo.models[this.nowModelIndex][str].scale,
              this.modelInfo.models[this.nowModelIndex][str].scale
            )
            break;
          case 'displacementMap':
            this.mesh.getObjectByName(this.nowModelName).material.displacementScale = new THREE.Vector2(
              this.modelInfo.models[this.nowModelIndex][str].scale,
              this.modelInfo.models[this.nowModelIndex][str].scale
            )
            break;
          default:
            break;
        }
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeMatAttr(pStr,str,conditionStr,val){
      this.modelInfo.models[this.nowModelIndex][pStr][str]=val
      this[conditionStr]=false
      if(this.modelInfo.models[this.nowModelIndex][pStr].selected){
          this.mesh.getObjectByName(this.nowModelName).material[pStr][str] = this.modelInfo.models[this.nowModelIndex][pStr][str]
          this.mesh.getObjectByName(this.nowModelName).material[pStr].needsUpdate = true
          this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeFlipY(str){
      this.modelInfo.models[this.nowModelIndex][str].flipY = !this.modelInfo.models[this.nowModelIndex][str].flipY
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
          this.mesh.getObjectByName(this.nowModelName).material[str].flipY = this.modelInfo.models[this.nowModelIndex][str].flipY
          this.mesh.getObjectByName(this.nowModelName).material[str].needsUpdate = true
          this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeWireframeUse(str){
      this.modelInfo.models[this.nowModelIndex][str].selected=!this.modelInfo.models[this.nowModelIndex][str].selected
      this.changeWireframe(str)
    },
    changeWireframe(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material[str] = true
        this.mesh.getObjectByName(this.nowModelName).material.wireframeLinecap = this.modelInfo.models[this.nowModelIndex][str].wireframeLinecap
        this.mesh.getObjectByName(this.nowModelName).material.wireframeLinejoin = this.modelInfo.models[this.nowModelIndex][str].wireframeLinejoin
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeMapUse(str){
      this.modelInfo.models[this.nowModelIndex][str].selected=!this.modelInfo.models[this.nowModelIndex][str].selected
      this.changeMatMap(str)
    },
    changeMatMap(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        if(this.modelInfo.models[this.nowModelIndex][str].url!=''){
          if(str=='envMap'){
            var texture = this.textrueLoader.load(this.modelInfo.models[this.nowModelIndex][str].url,(texture)=>{
              texture.encoding = THREE.GammaEncoding
              this.mesh.getObjectByName(this.nowModelName).material.envMap = this.pmremGenerator.fromEquirectangular(texture).texture
              // this.mesh.getObjectByName(this.nowModelName).material.envMap.needsUpdate = true
              this.changeIntensity('envMap')
            }) 
          }else{
            var texture = this.textrueLoader.load(this.modelInfo.models[this.nowModelIndex][str].url)
            texture.encoding = THREE.GammaEncoding
            texture.wrapT = texture.wrapS = THREE.RepeatWrapping
            texture.flipY = this.modelInfo.models[this.nowModelIndex][str].flipY
            if(this.modelInfo.models[this.nowModelIndex][str].magFilter!=''){
              texture.magFilter = THREE[this.modelInfo.models[this.nowModelIndex][str].magFilter]
            }
            if(this.modelInfo.models[this.nowModelIndex][str].minFiter!=''){
              texture.minFiter = THREE[this.modelInfo.models[this.nowModelIndex][str].minFiter]
            }
            if(this.modelInfo.models[this.nowModelIndex][str].anisotropy!=1){
              texture.anisotropy = THREE[this.modelInfo.models[this.nowModelIndex][str].anisotropy]
            }
            this.mesh.getObjectByName(this.nowModelName).material[str] = texture
            if(this.modelInfo.models[this.nowModelIndex][str].intensity){
              this.mesh.getObjectByName(this.nowModelName).material[str].intensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            }
            if(this.modelInfo.models[this.nowModelIndex][str].scale){
              switch(str){
                case 'normalMap':
                  this.mesh.getObjectByName(this.nowModelName).material.normalScale = new THREE.Vector2(
                    this.modelInfo.models[this.nowModelIndex][str].scale,
                    this.modelInfo.models[this.nowModelIndex][str].scale
                  )
                  break;
                case 'displacementMap':
                  this.mesh.getObjectByName(this.nowModelName).material.displacementScale = new THREE.Vector2(
                    this.modelInfo.models[this.nowModelIndex][str].scale,
                    this.modelInfo.models[this.nowModelIndex][str].scale
                  )
                  break;
                default:
                  break;
              }
            }
            if(this.modelInfo.models[this.nowModelIndex][str].bias){
              this.mesh.getObjectByName(this.nowModelName).material[str].bias = this.modelInfo.models[this.nowModelIndex][str].bias
            }
          }
        }
      }else{
        this.mesh.getObjectByName(this.nowModelName).material[str].dispose()
        this.mesh.getObjectByName(this.nowModelName).material[str] = null
      }
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
    },
    changeVolume(num){
      this.$refs['audio'+num][0].volume = this.bgms[num].volume/100
    },
    playAudio(num){
      this.audioIsPlaying = !this.audioIsPlaying
      this.$refs['audio'+num][0].play()
    },
    pauseAudio(num){
      this.audioIsPlaying = !this.audioIsPlaying
      this.$refs['audio'+num][0].pause()
    },
    saveCameraToHotPiont(num){
      this.$confirm('是否将当前相机视角保存为该热点数据的相机状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.hotPoints[num].cPosX = this.camera.position.x;
          this.hotPoints[num].cPosY = this.camera.position.y;
          this.hotPoints[num].cPosZ = this.camera.position.z;
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    deleteHotPiont(num){
      this.$confirm('确定删除此热点数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.hasSelected = false
          this.transformControls.detach(this.selectObj)
          this.hotPoints.splice(num,1);
          this.hotPointItemActive = 0;
          zcfCommon.removeChildFromGroup(this.hotPointGroup)
          for (let i = 0 ; i < this.hotPoints.length; i++){
            this.initHotPiont(this.hotPoints[i],i)
          }
          this.selectObj = this.scene.getObjectByName(this.hotPoints[this.hotPointItemActive].hotTitle+this.hotPointItemActive)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    uploadHotPointFile(str) {
      let file = this.$refs[str + 'Input'].files[0]
      console.log(file)
      var formData = new FormData()
      formData.append('file', file)
      formData.append('hashvalue', '')
      let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
      axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
        if(res.data.filePath) {
          this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
        }
      })
    },
    uploadBGM(str) {
      if(this.bgms.length>=1){
        this.$message({
          type: 'warning',
          message: '上传的背景音乐超限，请升级您的账户等级!'
        });   
      }else{
        let file = this.$refs[str + 'Input'].files[0]
        console.log(file)
        var formData = new FormData()
        formData.append('file', file)
        formData.append('hashvalue', '')
        let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
        axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
          if(res.data.filePath) {
            var arr= res.data.filePath.split('/');
            console.log(arr)
            var name = arr[arr.length - 1].replace('.mp3','')
            console.log(name)
            var json = {
              url: res.data.filePath,
              name: name,
              loop: false,
              volume: 100
            }
            this.bgms.push(json)
            // this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
          }
        })
      }
    },
    uploadLogo(str) {
      if(this.logos.length>=1){
        this.$message({
          type: 'warning',
          message: '上传的LOGO超限，请升级您的账户等级!'
        });   
      }else{
        let file = this.$refs[str + 'Input'].files[0]
        console.log(file)
        var formData = new FormData()
        formData.append('file', file)
        formData.append('hashvalue', '')
        let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
        axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
          if(res.data.filePath) {
            var arr= res.data.filePath.split('/');
            console.log(arr)
            var name = arr[arr.length - 1]
            console.log(name)
            var json = {
              url: res.data.filePath,
              name: name,
              pos: 'left top'
            }
            this.logos.push(json)
            // this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
          }
        })
      }
    },
    //弹窗
    showSnackbar(str) {
      this.logText = str
      this.snackbar = true
      console.log(this.selectObj)
    },
    //删除物体
    deleteLight(json) {
      console.log(json)
      var index = this.modelInfo.modelsLight.indexOf(json)
      console.log(index)
      if (index > -1) {
        this.modelInfo.modelsLight.splice(index, 1)
      }
    },
    //添加灯光
    addLight(json) {
      console.log(json)
      this.modelInfo.modelsLight.push(json)
      switch(json.type) {
        case 'AmbientLight':
          let ambientLight = new THREE.AmbientLight(json.color)
          ambientLight.name = json.name
          ambientLight.userData.id = json.id
          this.lightGroup.add(ambientLight)
          console.log(ambientLight)
          break
        case'DirectionalLight':
          let directionalLight = new THREE.DirectionalLight(json.color, json.intensity)
          directionalLight.name = json.name
          directionalLight.userData.id = json.id
          directionalLight.position.set(json.posX, json.posY, json.posZ)
          this.lightGroup.add(directionalLight)
          let directionalLightHelp = new THREE.DirectionalLightHelper(directionalLight, 0.2)
          directionalLightHelp.name = json.name + '_1'
          directionalLightHelp.userData.id = json.id
          this.lightHelpGroup.add(directionalLightHelp)
          break
        default:
          break
      }
      console.log(this.lightGroup)
    },
    //根据材质checkbox改变材质是否作用
    changeMapUseful(prop, val, url) {
      console.log(prop, val, url)
      if(val) {
        // var texture = new THREE.TextureLoader().load('http://localhost:5263' + url)
        // texture.
        // this.selectObj.material[prop] = texture
        // this.selectObj.material.needsupdate = true
        // console.log(this.selectObj.material)
        this.changeMaterial(prop, '' + url)
      }else{
        // this.selectObj.material[prop] = null
        var mat = this.selectObj.material.clone()
        this.selectObj.material.dispose()
        this.selectObj.material = null
        mat[prop] = null
        this.selectObj.material = mat
        // this.selectObj.material = new THREE.MeshStandardMaterial()
        // console.log(this.selectObj.material[prop])
      }
    },
    //根据面板操作改变场景中材质
    changeMaterial(prop, val) {
      switch(prop) {
        case 'color':
          this.selectObj.material.color.set(val)
          break
        case 'roughness':
        case 'metalness':
        case 'opacity':
        case 'alphaTest':
        case 'displacementScale':
        case 'envMapIntensity':
        case 'lightMapIntensity':
        case 'aoMapIntensity':
          this.selectObj.material[prop] = parseFloat(val)
          break
        case 'transparent':
        case 'wireframe':
        case 'depthTest':
        case 'depthWrite':
          this.selectObj.material[prop] = val
          break
        case 'normalScale':
          this.selectObj.material.normalScale = new THREE.Vector2(val, val)
          break
        case 'side':
          this.selectObj.material[prop] = this.sideTypes[val]
          break
        case 'map':
        case 'normalMap':
        case 'displaceMap':
        case 'roughnessMap':
        case 'metalnessMap':
        case 'lightMap':
        case 'aoMap':
        case 'emissiveMap':
        case 'alphaMap':
          var texture = new THREE.TextureLoader().load(val)
          texture.encoding = THREE.GammaEncoding
          if(this.modelInfo.sceneType === 'gltf') {
            texture.flipY = false
          }
          var mat = this.selectObj.material.clone()
          this.selectObj.material.dispose()
          this.selectObj.material = null
          mat[prop] = texture
          this.selectObj.material = mat
          break
        case 'envMap':
          new THREE.TextureLoader().load(val, (texture) => {
            texture.encoding = THREE.GammaEncoding
            var mat = this.selectObj.material.clone()
            this.selectObj.material.dispose()
            this.selectObj.material = null
            mat[prop] = texture
            mat[prop] = this.pmremGenerator.fromEquirectangular(texture).texture
            this.selectObj.material = mat
          })
          break
        default:
          break
      }
      console.log(this.selectObj.material)
    },
    //改变物体的接受和产生阴影属性
    changeShadow(str, val) {
      this.selectObj[str] = val
    },
    //改变相机状态
    changeCamera(str, val) {
      this.camera[str] = val
      console.log(this.camera)
      this.camera.updateProjectionMatrix()
      this.controls.update()
      this.render()
    },
    //改变灯光强度
    changeLightIntensity(val) {
      console.log(val)
      if(val > 0 && val <= 10.0) {
        this.selectObj.intensity = val
      }else{
        this.logText = '请输入0到10之间的数值'
        this.snackbar = true
      }
    },
    //改变灯光颜色
    changeLightColor(val) {
      console.log(this.selectObj)
      this.selectObj.color.set(val)
    },
    //根据编辑面板的数据来操作选中物体的位置缩放和旋转和阴影属性
    posSelectObj(prop, str, val) {
      if(prop === 'rotation') {
        val = Math.PI * val / 180
      }
      this.mesh[prop][str] = val
      // if(this.selectObj.name === 'camera') {
      //   this.camera.updateProjectionMatrix()
      //   this.controls.update()
      // }
    },
    //操作相机
    posCamera(prop, str, val) {
      if(prop === 'fov') {
        this.camera[prop] = val
      }else if(prop === 'near') {
        this.camera[prop] = val
      }else if(prop === 'far') {
        this.camera[prop] = val
      }else{
        this.camera[prop][str] = val
      }
      this.camera.updateProjectionMatrix()
      this.controls.update()
    },
    //将当前相机状态保存为初始相机状态
    saveCamera(){
      console.log(this.cPosX)
      this.modelInfo.camera.posX = this.cPosX
      this.modelInfo.camera.posY = this.cPosY
      this.modelInfo.camera.posZ = this.cPosZ
      this.modelInfo.camera.fov = this.cFov
      this.modelInfo.camera.near = this.cNear
      this.modelInfo.camera.far = this.cFar
      console.log(this.modelInfo.camera)
    },
    //操作场景列表来选中场景中的物体
    selectObjFn(str) {
      console.log(str)
      if(str !== 'noSelected') {
        if(this.hasSelected) {
          // this.transformControls.detach(this.selectObj)
        }
        if(str === 'camera' || str === 'ambientlight') {
          this.selectObj = this.scene.getObjectByName(str)
        }else{
          this.selectionBox.visible = true
          this.selectObj = this.scene.getObjectByName(str)
          this.selectionBox.setFromObject(this.selectObj)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
        }
      }else{
        if(this.hasSelected) {
          this.transformControls.detach(this.selectObj)
        }
        this.selectionBox.visible = false
        this.hasSelected = false
        this.selectObj = null
      }
    },
    //根据传入之初始灯光
    initLights(lights) {
      this.activeLightType = lights[0].type
      for (let i = 0; i < lights.length; i++) {
        let element = lights[i]
        switch(lights[i].type) {
          case 'AmbientLight':
            let ambientLight = new THREE.AmbientLight(lights[i].color)
            ambientLight.name = lights[i].name
            ambientLight.userData.id = lights[i].id
            this.lightGroup.add(ambientLight)
            break
          case'DirectionalLight':
            let directionalLight = new THREE.DirectionalLight(lights[i].color, lights[i].intensity)
            directionalLight.name = lights[i].name
            directionalLight.userData.id = lights[i].id
            directionalLight.position.set(lights[i].posX, lights[i].posY, lights[i].posZ)
            this.lightGroup.add(directionalLight)
            let directionalLightHelp = new THREE.DirectionalLightHelper(directionalLight, 0.2)
            directionalLightHelp.name = lights[i].name + '_1'
            directionalLightHelp.userData.id = lights[i].id
            this.lightHelpGroup.add(directionalLightHelp)
            break
          default:
            break
        }
      }
    },
    //遍历模型数据 保存到后台
    postModels() {
      this.mesh.traverse((child) => {
        if (child.isMesh) {
          console.log(child.name)
          this.modelNames.push(child.name)
          let mat = new THREE.MeshStandardMaterial()
          mat.color = new THREE.Color(0xffffff)
          mat.needsUpdate = true
          child.material = mat
          let jsonGeometry = {}
          jsonGeometry.posX = child.position.x.toFixed(4)
          jsonGeometry.posY = child.position.y.toFixed(4)
          jsonGeometry.posZ = child.position.z.toFixed(4)
          jsonGeometry.rotationX = (child.rotation.x / Math.PI * 180).toFixed(4)
          jsonGeometry.rotationY = (child.rotation.y / Math.PI * 180).toFixed(4)
          jsonGeometry.rotationZ = (child.rotation.z / Math.PI * 180).toFixed(4)
          jsonGeometry.scaleX = child.scale.x.toFixed(4)
          jsonGeometry.scaleY = child.scale.y.toFixed(4)
          jsonGeometry.scaleZ = child.scale.z.toFixed(4)
          jsonGeometry.castShadow = child.castShadow
          jsonGeometry.receiveShadow = child.receiveShadow
          let jsonMaterial = {}
          jsonMaterial.materialType = 'MESHSTANDARDMATERIAL'
          jsonMaterial.color = '#ffffff'
          jsonMaterial.emissive = '#000000'
          jsonMaterial.roughness = 0.5
          jsonMaterial.metalness = 0.5
          jsonMaterial.refractionRatio = 0.98
          jsonMaterial.side = 'FrontSide'
          jsonMaterial.blending = 'NormalBlending'
          jsonMaterial.transparent = false
          jsonMaterial.opacity = 1.0
          jsonMaterial.alphaTest = 0.0
          jsonMaterial.fog = 0.0
          jsonMaterial.depthWrite = true
          jsonMaterial.depthTest = true
          jsonMaterial.wireframe = {
            selected: false,
            wireframeLinecap:'round',
            wireframeLinejoin:'round'
          }
          jsonMaterial.map = {
            url: '',
            selected: false,
            flipY:true,
            magFilter:'LinearFilter',
            minFilter:'LinearMipmapLinearFilter',
            anisotropy: 1
          }
          jsonMaterial.normalMap = {
            url: '',
            selected: false,
            flipY:true,
            scale:1
          }
          jsonMaterial.displacementMap = {
            url: '',
            selected: false,
            flipY:true,
            scale:1,
            bias:0
          }
          jsonMaterial.roughnessMap = {
            url: '',
            selected: false,
            flipY:true
          }
          jsonMaterial.metalnessMap = {
            url: '',
            selected: false,
            flipY:true
          }
          jsonMaterial.envMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.lightMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.aoMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.emissiveMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.alphaMap = {
            url: '',
            selected: false,
            flipY:true
          }
          this.modelInfo.models.push({
            name: child.name,
            uuid: child.id,
            type: 'mesh',
            sceneID: this.modelID,
            ...jsonGeometry,
            ...jsonMaterial
          })
        }
      })
      this.nowModelName = this.modelNames[0]
      this.modelInfo.posX = this.mesh.position.x.toFixed(4)
      this.modelInfo.posY = this.mesh.position.y.toFixed(4)
      this.modelInfo.posZ = this.mesh.position.z.toFixed(4)
      this.modelInfo.rotationX = (this.mesh.rotation.x / Math.PI * 180).toFixed(4)
      this.modelInfo.rotationY = (this.mesh.rotation.y / Math.PI * 180).toFixed(4)
      this.modelInfo.rotationZ = (this.mesh.rotation.z / Math.PI * 180).toFixed(4)
      this.modelInfo.scaleX = this.mesh.scale.x.toFixed(4)
      this.modelInfo.scaleY = this.mesh.scale.y.toFixed(4)
      this.modelInfo.scaleZ = this.mesh.scale.z.toFixed(4)
      this.modelInfo.castShadow = this.mesh.castShadow
      this.modelInfo.receiveShadow = this.mesh.receiveShadow
      this.mesh.name = this.modelInfo.name
      this.scene.add(this.mesh)
      this.modelData = zcfCommon.getModelDate(this.mesh,THREE)
      if(this.modelData.r<10){
        this.$message({
          type: 'warn',
          message: '模型尺寸过小，请放大模型再进行其他操作！'
        });
      }
      // https.fetchPost('/AddModels', {
      //   models: this.modelInfo.models
      // }).then(res => {
      //   // console.log(this.modelInfo)
      //   // console.log(res)
      //   // this.modelInfo.models = res.data.result
      //   location.reload()
      //   // this.modelInfo = res.result
      // })
    },
    //根据后台数据设置物体材质
    initChild() {
      // let textureFlipY = true
      // if(this.modelInfo.sceneType === 'gltf') {
      //   textureFlipY = false
      // }
      this.mesh.traverse((child) => {
        if (child.isMesh) {
          let name = child.name
          this.modelNames.push(name)
          let childInfo = this.modelInfo.models.filter(
            item => {
              return item.name === child.name
            }
          )[0]
          child.castShadow = childInfo.castShadow
          child.receiveShadow = childInfo.receiveShadow
          var mat = new THREE.MeshStandardMaterial()
          mat.color = new THREE.Color(childInfo.color)
          mat.roughness = childInfo.roughness
          mat.metalness = childInfo.metalness
          var textrueLoader = new THREE.TextureLoader()
          if(childInfo.map.url !== '' && childInfo.map.selected) {
            var mapTexture = textrueLoader.load(childInfo.map.url)
            mapTexture.encoding = THREE.GammaEncoding
            mapTexture.flipY = childInfo.map.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.map = mapTexture
          }
          if(childInfo.normalMap.url !== '' && childInfo.normalMap.selected) {
            var normalTexture = textrueLoader.load(childInfo.normalMap.url)
            normalTexture.encoding = THREE.GammaEncoding
            normalTexture.flipY = childInfo.normalMap.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.normalMap = normalTexture
            mat.normalScale = new THREE.Vector2(childInfo.normalMap.scale,childInfo.normalMap.scale)
          }
          if(childInfo.metalnessMap.url !== '' && childInfo.metalnessMap.selected) {
            var metalnessTexture = textrueLoader.load(childInfo.metalnessMap.url)
            metalnessTexture.encoding = THREE.GammaEncoding
            metalnessTexture.flipY = childInfo.metalnessMap.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.metalnessMap = metalnessTexture
          }

          if(childInfo.aoMap.url !== '' && childInfo.aoMap.selected) {
            var aoTexture = textrueLoader.load(childInfo.aoMap.url)
            aoTexture.encoding = THREE.GammaEncoding
            aoTexture.flipY = childInfo.aoMap.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.aoMap = aoTexture
          }

          if(childInfo.roughnessMap.url !== '' && childInfo.roughnessMap.selected) {
            var roughnessTexture = textrueLoader.load(childInfo.roughnessMap.url)
            roughnessTexture.encoding = THREE.GammaEncoding
            roughnessTexture.flipY = childInfo.roughnessMap.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.roughnessMap = roughnessTexture
          }
          if(childInfo.alphaMap.url !== '' && childInfo.alphaMap.selected) {
            var alphaMapTexture = textrueLoader.load(childInfo.alphaMap.url)
            alphaMapTexture.encoding = THREE.GammaEncoding
            alphaMapTexture.flipY = childInfo.alphaMap.flipY
            mapTexture.wrapT = mapTexture.wrapS = THREE.RepeatWrapping
            mat.alphaMap = alphaMapTexture
          }
          if(childInfo.envMap.url !== '' && childInfo.envMap.selected) {
            textrueLoader.load(childInfo.envMap.url, (texture) => {
              texture.encoding = THREE.GammaEncoding
              mat.envMap = this.pmremGenerator.fromEquirectangular(texture).texture
              mat.needsUpdate = true
              texture.dispose()
            })
          }
          mat.envMapIntensity = childInfo.envMap.intensity
          mat.transparent = childInfo.transparent
          mat.opacity = childInfo.opacity
          mat.alphaTest = childInfo.alphaTest
          mat.wireframe = childInfo.wireFrame
          mat.needsUpdate = true
          mat.side = this.sideTypes[childInfo.side]
          child.material = mat
          // child.scale.set(childInfo.scaleX, childInfo.scaleY, childInfo.scaleZ)
          // child.position.set(childInfo.posX, childInfo.posY, childInfo.posZ)
          // child.rotation.set(childInfo.rotationX * Math.PI / 180, childInfo.rotationY * Math.PI / 180, childInfo.rotationZ * Math.PI / 180)
        }
      })
      this.nowModelName = this.modelNames[0]
      this.mesh.scale.set(this.modelInfo.scaleX, this.modelInfo.scaleY, this.modelInfo.scaleZ)
      this.mesh.position.set(this.modelInfo.posX, this.modelInfo.posY, this.modelInfo.posZ)
      this.mesh.rotation.set(this.modelInfo.rotationX/180*Math.PI, this.modelInfo.rotationY/180*Math.PI, this.modelInfo.rotationZ/180*Math.PI)
      this.mesh.castShadow = this.modelInfo.castShadow
      this.mesh.receiveShadow = this.modelInfo.receiveShadow
      this.mesh.name = this.modelInfo.name
      this.modelData = zcfCommon.getModelDate(this.mesh,THREE)
      this.scene.add(this.mesh)

      for (let i = 0 ; i < this.hotPoints.length; i++){
        this.initHotPiont(this.hotPoints[i],i)
      }
    },
    generateTextureWithText(message) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      context.font = 'italic small-caps bold 24px Heiti '

      var metrics = context.measureText(message)
      var textWidth = metrics.width
      canvas.width = canvas.height = (textWidth + 40) * 2
      context.fillStyle = 'rgba(127,127,127,1.0)'
      context.strokeStyle = 'rgba(255,255,255,1.0)'
      context.lineWidth = 10
      // this.roundRect(context, 0, 0, canvas.width, canvas.height, 2)
      context.beginPath();
      context.arc(canvas.width/2,canvas.width/2,canvas.width/2-5,0,Math.PI*2,true);
      context.closePath()
      context.fill()
      context.stroke()
      context.fillStyle = 'rgba(255, 255, 255, 1.0)'
      context.font = 'small-caps 60px Heiti'
      context.fillText(message, 36, canvas.height/2+20)
      var texture = new THREE.Texture(canvas);
      texture.format = THREE.RGBAFormat;
      texture.magFilter = THREE.LinearFilter;
      texture.minFilter = THREE.LinearFilter;
      texture.needsUpdate = true;
      return texture;
    },
    initHotPiont(info,num){
      var spriteMap = this.generateTextureWithText(num+1);
      var spriteMaterial = new THREE.SpriteMaterial({
        map: spriteMap,
        color: 0xffffff
      })
      var sprite = new THREE.Sprite(spriteMaterial)
      sprite.scale.set(
        this.modelData.r/80,
        this.modelData.r/80, 
        this.modelData.r/80
      )
      sprite.hotType = info.type
      sprite.position.set(parseFloat(info.posX), parseFloat(info.posY), parseFloat(info.posZ))
      sprite.name = info.title+num
      this.hotPointGroup.add(sprite)
    },
    roundRect(ctx, x, y, w, h) {
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x + w, y)
      ctx.lineTo(x + w, y + h)
      ctx.lineTo(x, y + h)
      ctx.lineTo(x, y)
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
    },
    tweenCamera(pos, fn) {
      var x = parseFloat(pos.x)
      var y = parseFloat(pos.y)
      var z = parseFloat(pos.z)
      console.log(x,y,z)
      new TWEEN.Tween(this.camera.position)
        .to({ x: x,y:y,z:z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(function () {
          vm.camera.updateProjectionMatrix()
        }).onComplete(function () {
          console.log(vm.camera.position)
        })
    },
    // 场景初始
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.scene.add(this.lightGroup)
      this.scene.add(this.lightHelpGroup)
      this.lightHelpGroup.visible = false
      this.scene.add(this.hotPointGroup)
      this.hotPointGroup.visible = false
      let modelLoader
      https.fetchGet('/GetSceneInfo', {
        id: this.modelID
      }).then(
        res => {
          if(res.status === 200) {
            console.log(res)
            this.modelInfo = res.data
            document.title =  this.modelInfo.name
            this.modelName = this.modelInfo.name
            this.bgcolor = this.modelInfo.backGround.color
            this.bgOn = this.modelInfo.backGroundShow
            this.activeBgName = this.modelInfo.backGround.type
            this.activeNum = this.modelInfo.backGround.activeNum
            this.bgActiveImage = this.modelInfo.backGround.url


            this.cFov = this.modelInfo.camera.fov
            this.cNear = this.modelInfo.camera.near
            this.cFar = this.modelInfo.camera.far
            this.cPosX = this.modelInfo.camera.posX
            this.cPosY = this.modelInfo.camera.posY
            this.cPosZ = this.modelInfo.camera.posZ
            
            if(this.modelInfo.backMusic){
              this.bgms.push(this.modelInfo.backMusic)
            }
            this.bgmOn = this.modelInfo.backMusicShow 
            if(this.modelInfo.logo){
              this.logos.push(this.modelInfo.logo)
            }
            this.logoOn = this.modelInfo.logoShow
            this.hotPoints = this.modelInfo.hotPoint
            this.camera = new THREE.PerspectiveCamera(
              this.cFov,
              this.containerW / this.containerH,
              this.cNear,
              this.cFar
            )
            this.camera.position.set(this.cPosX, this.cPosY, this.cPosZ)
            this.camera.name = this.modelInfo.camera.name
            this.scene.add(this.camera)
            this.initLights(this.modelInfo.modelsLight)

            // helpers

            let grid = new THREE.GridHelper(30, 30, 0x444444, 0x888888)
            this.scene.add(grid)

            this.selectionBox = new THREE.BoxHelper()
            this.selectionBox.material.depthTest = false
            this.selectionBox.material.transparent = true
            this.selectionBox.visible = false
            this.scene.add(this.selectionBox)

            this.renderer = new THREE.WebGLRenderer({
              antialias: true,
              alpha: true
            })
            this.renderer.outputEncoding = THREE.GammaEncoding
            this.renderer.shadowMap.enabled = true
            this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
            this.renderer.setPixelRatio(window.devicePixelRatio)
            this.renderer.setSize(this.containerW, this.containerH)
            // this.renderer.toneMapping = THREE.Uncharted2ToneMapping
            // this.renderer.toneMappingExposure = 0.75

            this.container.appendChild(this.renderer.domElement)

            //controls
            let objectPositionOnDown = null
            let objectRotationOnDown = null
            let objectScaleOnDown = null
            this.controls = new OrbitControls(this.camera, this.renderer.domElement)
            this.controls.enableDamping = true
            this.controls.dampingFactor = 0.1
            // this.controls.update()
            this.controls.addEventListener('change', () => {
              this.cPosX = this.camera.position.x.toFixed(4)
              this.cPosY = this.camera.position.y.toFixed(4)
              this.cPosZ = this.camera.position.z.toFixed(4)
            })

            this.transformControls = new TransformControls(this.camera, this.renderer.domElement)
            this.transformControls.addEventListener('change', () => {
              var object = this.transformControls.object
              if (object !== undefined) {
                if(this.activePanelNum==1){
                    this.modelInfo.modelsLight[this.lightItemActive].posX = parseFloat(object.position.x)
                    this.modelInfo.modelsLight[this.lightItemActive].posY = parseFloat(object.position.y)
                    this.modelInfo.modelsLight[this.lightItemActive].posZ = parseFloat(object.position.z)
                }
                if(this.activePanelNum==4){
                  this.modelInfo.hotPoint[this.hotPointItemActive].posX = parseFloat(object.position.x)
                  this.modelInfo.hotPoint[this.hotPointItemActive].posY = parseFloat(object.position.y)
                  this.modelInfo.hotPoint[this.hotPointItemActive].posZ = parseFloat(object.position.z)
                }
                //防止change事件调用是，物体还未被选中
                // if(this.$refs.editMenu.nowSelectIndex !== -1) {
                  // if(this.selectObj.type === 'Group' || this.selectObj.type === 'Mesh') {
                  //   this.selectionBox.setFromObject(this.selectObj)
                  // }

                  // if(this.selectObj.type !== 'Group') {
                  //   this.$refs.editMenu.getDetails[this.$refs.editMenu.nowSelectIndex].posX = this.selectObj.position.x.toFixed(4)
                  //   this.$refs.editMenu.getDetails[this.$refs.editMenu.nowSelectIndex].posY = this.selectObj.position.y.toFixed(4)
                  //   this.$refs.editMenu.getDetails[this.$refs.editMenu.nowSelectIndex].posZ = this.selectObj.position.z.toFixed(4)
                  // }else {
                  //   this.modelInfo.posX = this.selectObj.position.x.toFixed(4)
                  //   this.modelInfo.posY = this.selectObj.position.y.toFixed(4)
                  //   this.modelInfo.posZ = this.selectObj.position.z.toFixed(4)
                  // }
                // }
              }
              // this.render()
            })
            this.transformControls.addEventListener('dragging-changed', (event) => {
              this.controls.enabled = !event.value
            })
            // this.transformControls.addEventListener('mouseDown', (evt) => {
            //   // 平移开始时禁用相机控件
            //   this.controls.enabled = false;
            // })
            // this.transformControls.addEventListener('mouseUp', (evt) => {
            //   // 平移结束时启用相机控件
            //   this.controls.enabled = true;
            // })
            this.scene.add(this.transformControls)
            let textrueLoader = new THREE.TextureLoader()
            let envMap
            this.pmremGenerator = new THREE.PMREMGenerator(this.renderer)
            this.pmremGenerator.compileEquirectangularShader()
            textrueLoader.load('env/EnvMap01.jpg', (texture) => {
              texture.encoding = THREE.sRGBEncoding

              let pngCubeRenderTarget = this.pmremGenerator.fromEquirectangular(texture)

              envMap = pngCubeRenderTarget.texture

              texture.dispose()
            })
            switch(this.modelInfo.sceneType) {
              case 'fbx':
                modelLoader = new FBXLoader()
                modelLoader.load('' + this.modelInfo.modelUrl + '/model.FBX', (object) => {
                // modelLoader.load('models/erji/model.FBX', (object) => {
                  this.mesh = object
                  this.mesh.name = this.modelInfo.name
                  this.treeData = []
                  // var model = this.getRecursionNode(this.mesh)
                  this.genTreeData(this.mesh,this.treeData)
                  if(this.modelInfo.models.length <= 0) {
                    this.postModels()
                  }else{
                    this.initChild()
                  }
                })
                break
              case 'gltf':
                modelLoader = new GLTFLoader()
                var dracoLoader = new DRACOLoader()
                dracoLoader.setDecoderPath('com/draco/gltf/')
                modelLoader.setDRACOLoader(dracoLoader)
                modelLoader.setPath(this.modelInfo.modelUrl + '/')
                modelLoader.load('model.gltf', gltf => {
                  this.mesh = gltf.scene
                  this.treeData = []
                  // var model = this.getRecursionNode(this.mesh)
                  this.genTreeData(this.mesh,this.treeData)
                  if(this.modelInfo.models.length <= 0) {
                    this.postModels()
                  }else{
                    this.initChild()
                  }
                  console.log(this.mesh)
                  // var modelData = zcfCommon.getModelDate(this.mesh,THREE);
                  // zcfCommon.initCamera(this.camera,modelData,this.controls);
                })
                break
              case 'obj':
                modelLoader = new MTLLoader()
                modelLoader.setPath(this.modelInfo.modelUrl + '/')
                modelLoader.load('model.mtl', materials => {
                  materials.preload()
                  new OBJLoader()
                    .setMaterials(materials)
                    .setPath(this.modelInfo.modelUrl + '/')
                    .load('model.obj', object => {
                      this.mesh = object
                      this.treeData = []
                      // var model = this.getRecursionNode(this.mesh)
                      this.genTreeData(this.mesh,this.treeData)
                      if(this.modelInfo.models.length <= 0) {
                        this.postModels()
                      }else{
                        this.initChild()
                      }
                    })
                })
                break
              default:
                break
            }
            window.addEventListener('resize', this.onresize, false)
            window.addEventListener( 'keydown', function ( event ) {
              switch ( event.keyCode ) {
                case 81: // Q
                  vm.transformControls.setSpace( vm.transformControls.space === "local" ? "world" : "local" );
                  break;
                case 16: // Shift
                  vm.transformControls.setTranslationSnap( 100 );
                  vm.transformControls.setRotationSnap( THREE.MathUtils.degToRad( 15 ) );
                  vm.transformControls.setScaleSnap( 0.25 );
                  break;
                case 87: // W
                  vm.transformControls.setMode( "translate" );
                  break;
                case 69: // E
                  vm.transformControls.setMode( "rotate" );
                  break;
                case 82: // R
                  vm.transformControls.setMode( "scale" );
                  break;
              }
            });
            window.addEventListener( 'keyup', function ( event ) {
              switch ( event.keyCode ) {
                case 16: // Shift
                  vm.transformControls.setTranslationSnap( null );
                  vm.transformControls.setRotationSnap( null );
                  vm.transformControls.setScaleSnap( null );
                  break;
              }
            });
            this.renderer.domElement.addEventListener('mousedown', this.onMouseDown, false)
            this.renderer.domElement.addEventListener('mouseup', this.onMouseUp, false)
            // this.renderer.domElement.addEventListener('mousedown', this.onRendererMouseDown, false)
            // this.renderer.domElement.addEventListener('mousemove', this.onRendererMouseMove, false)
            // this.renderer.domElement.addEventListener('mouseup', this.onRendererMouseUp, false)
            // this.renderer.domElement.addEventListener('wheel', this.onDocumentMouseWheel, false)
            // this.renderer.domElement.addEventListener('touchstart', this.onRendererTouchStart, false)
            // this.renderer.domElement.addEventListener('touchmove', this.onRendererTouchMove, false)
            // this.renderer.domElement.addEventListener('touchend', this.onRendererTouchEnd, false)
            this.animate()
          }else{

          }
        },
        err => {
          console.log(err)
        }).catch(error => {
        console.log(error)
      })
    },
    genTreeData(obj,json){
      if(obj.children.length>0){
        var newJson ={
          label:obj.name,
          id:obj.id,
          children:[]
        }
        json.push(newJson)
        for (let index = 0; index < obj.children.length; index++) {
          let elem = obj.children[index]
          this.genTreeData(elem,newJson.children)
        }
      }else{
         json.push({
           label:obj.name,
           id:obj.id,
           children:[]
         })
      }
    },
    getRecursionNode(obj){
      var model = obj
      if(model.children.length>0){
        if(model.children.length>1){
          return model
        }else{
          return this.getRecursionNode(model.children[0])
        }
      }else{
        return model
      }
    },
    onMouseDown(ev) {
      var array = this.getMousePosition(this.container, ev.clientX, ev.clientY)
      this.onDownPosition.fromArray(array)
    },
    getObjectIndexByID(str){
      console.log(str)
      var reIndex = -1;
      for (let index = 0; index < this.modelInfo.models.length; index++) {
        const element = this.modelInfo.models[index];
        if(element.uuid == str){
          reIndex = index
          break
        }
      }
      return reIndex
    },
    getObjectIndexByName(str){
      var reIndex = -1;
      for (let index = 0; index < this.modelInfo.models.length; index++) {
        const element = this.modelInfo.models[index];
        if(element.name == str){
          reIndex = index
          break
        }
      }
      return reIndex
    },
    onMouseUp(ev) {
      var array = this.getMousePosition(this.container, ev.clientX, ev.clientY)
      this.onUpPosition.fromArray(array)
      if (this.onDownPosition.distanceTo(this.onUpPosition) === 0) {
        this.mouse.x = ((ev.clientX-321 -this.containerW) / this.containerW) * 2 + 1
        this.mouse.y = -((ev.clientY-56 - this.containerH) / this.containerH) * 2 - 1
        this.raycaster.setFromCamera(this.mouse, this.camera)
        let intersections = this.raycaster.intersectObjects(this.mesh.children, true)
        if(intersections.length > 0) {
          if(this.activePanelNum == 2){
            this.selectionBox.visible = true
            this.selectObj = intersections[0].object
            console.log(this.selectObj)
            this.selectionBox.setFromObject(this.selectObj)
            this.transformControls.attach(this.selectObj)
            this.hasSelected = true
            console.log(this.modelInfo.models)
            this.nowModelName=this.selectObj.name
            this.nowModelIndex=this.getObjectIndexByName(this.nowModelName)
          }
          if(this.activePanelNum == 4){
            this.$confirm('是否将当前点作为热点信息点?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              var pos = new THREE.Vector3();
              pos = intersections[0].point.clone();
              pos.add(intersections[0].face.normal.multiplyScalar(0.1))
              console.log(pos)
              var hotInfo={
                cPosX:parseFloat(this.camera.position.x.toFixed(4)),
                cPosY:parseFloat(this.camera.position.y.toFixed(4)),
                cPosZ:parseFloat(this.camera.position.z.toFixed(4)),
                type:1,
                title:'标题',
                posX:parseFloat(pos.x.toFixed(4)),
                posY:parseFloat(pos.y.toFixed(4)),
                posZ:parseFloat(pos.z.toFixed(4)),
                hotContent:'内容'
              };
              this.hotPoints.push(hotInfo);
              this.initHotPiont(hotInfo,this.hotPoints.length-1)
              // console.log(this.hotPointGroup);
              this.hotPointItemActive = this.hotPoints.length-1
              this.selectionBox.visible = true
              this.selectObj = this.scene.getObjectByName(hotInfo.title+this.hotPointItemActive)
              this.transformControls.attach(this.selectObj)
              this.hasSelected = true
              this.$message({
                type: 'success',
                message: '添加成功!'
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消添加'
              });          
            });
          }
        }else{
          this.selectionBox.visible = false
          this.transformControls.detach(this.selectObj)
          this.hotPointItemActive = -1
          this.lightItemActive = -1
          // this.$refs.editMenu.selectMenu('noSelected')
        }
      }
    },
    //获取鼠标坐标
    getMousePosition(dom, x, y) {
      var rect = dom.getBoundingClientRect()
      return [ (x - rect.left) / rect.width, (y - rect.top) / rect.height ]
    },
    // 窗口改变
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    // 循环渲染
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate () {
      this.rafId = requestAnimationFrame(this.animate)
      // this.hasSelected ? this.transformControls.update() : this.controls.update()
      for(var i = 0; i < this.lightHelpGroup.children.length; i++) {
        this.lightHelpGroup.children[i].update()
      }
      this.controls.update()
      TWEEN.update()
      this.render()
    },
    // 暴露出去的方法
    changeColor () {
      this.mesh.traverse(function (child) {
        if (child.isMesh) {
          child.material.color = new THREE.Color(0xff0000)
        }
      })
    },
    handleUploadSuccess(res, file, str) {
        console.log(res)
        // console.log(file)
        // this[str] = URL.createObjectURL(file.raw);
        this.modelInfo.models[this.nowModelIndex][str].url = res.filePath
        this.changeMatMap(str)
      },
    tabHandleClick(tab, event) {
      // console.log(tab, event)
      this.activeBgName = tab.name
      this.modelInfo.backGround.type = tab.name
      if(this.activeBgName==='image'){
        this.bgActiveNum = 0
        this.bgActiveImage = 'url(images/bgs/1.jpeg)'
        this.modelInfo.backGround.activeNum = 0
        this.modelInfo.backGround.url = 'url(images/bgs/1.jpeg)'
      }else{
        this.bgActiveImage = ''
        this.modelInfo.backGround.url = ''
      }
    },
    lightTypeHandleClick(tab, event){
      console.log(tab, event)
    },
    changeBg(str,val,num){
      if(str==='image'){
        this.bgActiveNum = num
        this.bgActiveImage = 'url('+val+')'
        this.modelInfo.backGround.activeNum = num
        this.modelInfo.backGround.url = 'url('+val+')'
      }else{
        this.bgActiveImage = ''
        this.modelInfo.backGround.url = ''
        this.modelInfo.backGround.color = val
      }
      this.modelInfo.backGround.type=str
    },
    changePanel(num){
      this.activePanelNum = num
      this.selectionBox.visible = false
      this.hasSelected = false
      if(this.selectObj){
        this.transformControls.detach(this.selectObj)
      }
      this.lightHelpGroup.visible = false
      this.hotPointGroup.visible = false
      switch(this.activePanelNum){
        case 1:
          this.lightHelpGroup.visible = true
          this.lightItemActive = 0
          // if(this.modelInfo.modelsLight[this.lightItemActive].type!='AmbientLight'){
          this.selectionBox.visible = false
          this.selectObj = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)
          // this.selectionBox.setFromObject(this.selectObj)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          // }
          break;
        case 2:
          this.selectionBox.visible = !this.hideselectedstate
          this.selectObj = this.scene.getObjectByName(this.modelNames[0])
          this.selectionBox.setFromObject(this.selectObj)
          // this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          break;
        case 4:
          this.hotPointGroup.visible = true
          console.log(this.hotPoints)
          if(this.hotPoints.length>0){
            this.hotPointGroup.visible = true
            this.hotPointItemActive = 0
            var pos = new THREE.Vector3(
              this.hotPoints[this.hotPointItemActive].cPosX,
              this.hotPoints[this.hotPointItemActive].cPosY,
              this.hotPoints[this.hotPointItemActive].cPosZ
              )
            this.tweenCamera(pos)
            this.selectionBox.visible = true
            this.selectObj = this.scene.getObjectByName(this.hotPoints[this.hotPointItemActive].title+this.hotPointItemActive)
            this.transformControls.attach(this.selectObj)
            this.hasSelected = true

          }
          break;
        default:
          this.selectionBox.visible = false
          this.transformControls.detach(this.selectObj)
          this.hasSelected = false
          break;
      }
    },
    changeOnClose(str){
      this[str]=!this[str]
      switch(str){
        case 'bgOn':
          if(this.activeBgName=='image'){
            if(this.bgActiveImage==''){
              this.bgActiveImage = 'url(images/bgs/1.jpeg)'
              this.modelInfo.backGround.url = 'url(images/bgs/1.jpeg)'
            }
          }else{
            this.modelInfo.backGround.color=this.bgcolor
          }
          this.modelInfo.backGround.activeNum = this.bgActiveNum
          this.modelInfo.backGroundShow = this.bgOn
          break;
        case 'hideselectedstate':
          if(this.hideselectedstate){
            this.selectionBox.visible = false
            this.transformControls.detach(this.selectObj)
            this.hasSelected = false
          }else{
            this.selectionBox.visible = true
            this.selectObj = this.scene.getObjectByName(this.modelNames[0])
            this.selectionBox.setFromObject(this.selectObj)
            this.transformControls.attach(this.selectObj)
            this.hasSelected = true
          }
          break;
      }
    },
    changeLightItem(num,obj){
      this.lightItemActive = num
      // if(this.modelInfo.modelsLight[this.lightItemActive].type!='AmbientLight'){
        // this.selectionBox.visible = true
      this.selectObj = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)
        // this.selectionBox.setFromObject(this.selectObj)
      this.transformControls.attach(this.selectObj)
      this.hasSelected = true
      // }
    },
    changeHotItem(num,obj){
        this.hasSelected = false
        this.transformControls.detach(this.selectObj)
        this.hotPointItemActive = num
        var pos = new THREE.Vector3(
          this.hotPoints[this.hotPointItemActive].cPosX,
          this.hotPoints[this.hotPointItemActive].cPosY,
          this.hotPoints[this.hotPointItemActive].cPosZ
          )
        this.tweenCamera(pos)
        this.selectObj = this.scene.getObjectByName(obj.title+num)
        this.transformControls.attach(this.selectObj)
        this.hasSelected = true
    },
    changeLight(str,val){
      console.log(str,val)
      var light = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)

      if(str.substring(0, 8) === 'position'){
        var str1 = str.substring(0, 8)
        var str2 = str.substring(str.length-1)
        light[str1][str2] = val
      }else if(str=='castShadow'){
        this.modelInfo.modelsLight[this.lightItemActive][str] = !this.modelInfo.modelsLight[this.lightItemActive][str]
        light[str] = this.modelInfo.modelsLight[this.lightItemActive][str]
      }else if(str == 'color'){
        light[str].set(val)
      }else{
        light[str] = val
      }
    },
    saveOptions(){
      if(this.bgms.length>0){
        this.modelInfo.backMusic = this.bgms[0]
      }else{
        this.modelInfo.backMusic = null
      }
      this.modelInfo.backMusicShow = this.bgmOn
      if(this.logos.length>0){
        this.modelInfo.logo = this.logos[0]
      }else{
        this.modelInfo.logo = null
      }
      this.modelInfo.logoShow = this.logoOn
      this.modelInfo.hotPoint = this.hotPoints
      this.modelInfo.autoRotate = this.autoRotateOn
      console.log(this.modelInfo)
      https.fetchPost('/AddSceneModel', this.modelInfo).then(
        res => {
          if(res.status === 200) {
              this.$message({
                type: 'info',
                message: '保存成功'
              });    
          }else{
              this.$message({
                type: 'info',
                message: '保存失败，请重新保存'
              }); 
          }
        },
        err => {
          console.log(err)
          this.$message({
            type: 'info',
            message: '保存失败，请重新保存'
          }); 
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'info',
            message: '保存失败，请重新保存'
          }); 
        })
    },
    goWeb(str){
      switch (str) {
        case 'preview':
          this.$router.push({ path: "/scenePreview?id=" + this.modelID })
          // const{ href } = this.$router.resolve({name:"scenePreview",query:{id:this.modelID}});
          // window.open(href,'_blank');
          break;
        default:
          break;
      }
      
    }
  }
}
</script>
<style>
  @font-face{
      font-family: 'myiconfont';
      src: url('../../public/com/custom-icons.woff') format('woff');
  }
  .el-color-picker__icon{
    display: none!important;
  }
  .el-collapse-item__arrow{
    width:20px;
    height:20px;
    line-height: 20px;
    text-align: center;
    margin:0;
    padding: 0;
    position: relative;
    text-indent: 0
  }
  li{
    list-style: none;
  }
  .el-collapse{
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom:100px;
  }
  .editPanelWrap .el-collapse-item__header{
    background-color: #333 !important;
    border-bottom: 1px solid #000;
    color: #ccc;
    height:30px;
    text-indent: 10px;
  }
  .editPanelWrap .el-collapse-item__wrap{
    border-bottom: 1px solid #000;
  }
  .editPanelWrap .el-collapse-item__content{
    background-color:#595959;
    padding-bottom: 10px;
  }
  .editPanelWrap .el-form-item__label{
    color:#000;
  }
  .editPanelWrap .el-form-item{
    margin-bottom: 10px;
  }
  .editPanelWrap .el-input__inner{
    background-color: #333;
    border: 1px solid #595959;
    color:#fff;
    height:30px;
    box-sizing: border-box;
  }
  .editPanelWrap .el-input-group__prepend{
    color:#aaa;
    height:30px;
    box-sizing: border-box;
  }
  .editPanelWrap .el-input{
    width:200px;
    height:30px;
  }
  .editPanelWrap .el-tabs{
    border-radius: 4px 4px;
    overflow: hidden;
    border: none;
    background-color: #888;
    color:#aaa !important;
  }
  .editPanelWrap .el-tabs__item.is-active{
    background-color: #888!important;
    color:#fff !important;
    border: none !important;
  }
  .editPanelWrap .el-tabs__item{
    background-color: #333 !important;
    color:#aaa !important;
    border: none !important;
  }
  .lightWrap .el-button{
    width:100%;
  }
  .lightWrap .el-card{
    border: 1px solid #666 !important;
  }
  .hotpoint .el-card,.others .el-card{
    border: 1px solid #666 !important;
    overflow: hidden;
  }
  .lightWrap .el-card__body{
    padding: 5px !important;
  }
  .hotpoint .el-card__body,.others .el-card__body{
    padding: 5px !important;
  }
  .hotpoint .hotpointsWrap .el-card__body{
    height: 200px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .lightWrap .el-card__header,.hotpoint .el-card__header,.others .el-card__header{
    padding: 5px !important;
    border-bottom: none;
    background-color: #666;
  }
  .lightWrap .el-card__header span,.hotpoint .el-card__header span,.others .el-card__header span{
    width:100% !important;
    text-align: left;
    text-indent: 5px;
  }
  .el-color-picker__trigger{
    border: none;
  }
  .lightProWrap .el-tabs__item.is-top{
    padding: 0 4px!important;
  }
  /* .el-collapse{
    margin-bottom: 0;
  } */
  .material .item .el-color-picker__trigger{
    width:100px !important;
  }
  .hotpoint .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .hotpoint .el-scrollbar__view{
    overflow: hidden;
  }
  .hotpoint .item .el-textarea__inner{
    border: none;
    padding: 5px;
    background-color: #333;
    color:#fff;
    text-indent: 12px;
    font-size: 13px;
  }
  .hotpoint .el-button{
    padding: 5px 5px;
  }
  .hotpoint textarea {
    font: normal 13px "微软雅黑";
  }
  .others .el-button {
    width: 100%;
  }
</style>
<style scoped>
.wrap {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  color: white;
}
.wrap .editPanel{
  font-size: 16px;
  background-color: #595959;
  border-right: 1px solid #000;
  user-select: none;
  width: 321px;
  height: 100%;
  margin-top: 55px;
  box-sizing: border-box;
  position:absolute;
  z-index:2;
}
.wrap .editPanel .editPanelWrap{
  height: 100%;
  width: 100%;
  position: absolute;
  margin-top: 40px;
  margin-bottom: 40px;
  box-sizing: border-box;
  top:0;
  overflow-x: hidden;
  overflow-y: auto;
}
.lightWrap .box-card{
  margin-top: 10px;
  background-color: #333;
}
.lightWrap .lightItem{
  color:#fff;
  width:100%;
  height:30px;
  cursor: pointer;
}
.lightWrap .lightItem.active{
  background: #595959;
}
.lightWrap .lightItem span{
  display: inline-block;
  height:30px !important;
  line-height: 30px;
}
.lightWrap .lightItem .num{
  width:10% !important;
}
.lightWrap .lightItem .name{
  width:80% !important;
}
.lightWrap .lightItem i{
  width:10% !important;
}
.lightWrap .lightProWrap{
  background-color: #777;
}
.lightWrap .lightPro>div>div{
  margin-bottom: 5px;
}
.lightWrap .lightPro>div{
  margin-bottom: 5px;
}
.lightWrap .lightPro .color{
  height:40px;
  clear: both;
  overflow:hidden;
  position: relative;
}
.lightWrap .lightPro .color span{
  height:40px;
  line-height: 40px;
  vertical-align: middle;
  position: absolute;
}
.lightWrap .lightPro .color .el-color-picker{
  display: inline-block;
  margin-left: 40px;
}
.lightWrap .lightPro .castShadow{
  position: relative;
  height:24px;
}
.lightWrap .lightPro .castShadow>span{
  position:absolute;
  width:45px;
}
.lightWrap .lightPro .castShadow .state{
  margin-left: 195px;
}
.lightWrap .lightPro .castShadow .on{
  width:45px;
}
.state{
  width:50px;
  height:24px;
  position: relative;
  font-size:12px;
  line-height: 24px;    
  background: #1a1a1a;
  border-radius: 3px 3px;
  margin-left: 180px;
}
.state .on{
  position:absolute;
  display: block;
  width:100%;
  height:100%;
  left:0;
  top:0;
  text-indent: 5px;
  color:#1caad9;
}
.state .on .border{
  width:10px;
  height:20px;
  position:absolute;
  border-radius:3px 3px;
  background-color: #4d4d4d;
  top:2px;
  right:2px;
}
.state .off{
  position:absolute;
  display: block;
  width:45px;
  height:100%;
  right:5px;
  top:0;
  text-align: right;
}
.state .off .border{
  width:10px;
  height:20px;
  position:absolute;
  border-radius:3px 3px;
  background-color: #4d4d4d;
  top:2px;
  left:2px;
}
.state .on .border{
  width:10px;
  height:20px;
  position:absolute;
  border-radius:3px 3px;
  background-color: #4d4d4d;
  top:2px;
  right:2px;
}
.editPanelWrap .el-collapse-item ul{
  width: 100%;
  height: 200px;
  background-color: #333;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.editPanelWrap .el-collapse-item li{
  display: block;
  height:50px;
  position: relative;
  cursor: pointer;
  color:#fff;
}
.editPanelWrap li.active{
  background-color: #595959;
}
.editPanelWrap li img{
  display: inline-block;
  height: 40px;
  position: absolute;
  left:20px;
  top:5px;
}
.editPanelWrap li span{
  display: inline-block;
  line-height: 50px;
  position: absolute;
  right:100px;
}
.editPanelWrap .item{
  padding: 10px;
  box-sizing: border-box;
}
.editPanelWrap .item .el-divider{
  background-color: #333;
  margin: 12px 0;
}
.editPanelWrap .item>div{
  margin-bottom: 5px;
}
.editPanelWrap .item p{
  width:100px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color:#ccc;
  margin-bottom: 5px;
}
.basic .item span{
  display: inline-block;
  width:40px;
  color:#ccc;
}
.lightWrap .item span{
  display: inline-block;
  width:40px;
  color:#ccc;
}
.editPanelWrap .el-collapse-item__header{
  background-color: #333 !important;
}
.wrap .editPanel .editPanelTop{
  position: relative;
  height:40px;
  width:100;
  border-top: 1px solid #000;
  box-sizing: border-box;
}
.editPanelTop i{
  width:40px;
  height:39px;
  text-align: center;
  vertical-align: middle;
  line-height: 39px;
  background: #333;
  border-right: 1px solid #000;
  box-sizing: border-box;
  cursor: pointer;
}
.editPanelTop i:hover{
  background: #4d4d4d;
}
.editPanelTop i.active{
  background: #4d4d4d;
}
.wrap .editPanel .el-switch{
  margin-left: 60px;
}
.wrap .editView{
    z-index: 0;
    width: 100%;
    padding-left: 320px;
    overflow: hidden;
    background: gray;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding-top: 55px;
    box-sizing: border-box;
    display: block;
}
.wrap .editView .webgl{
  width: 100%;
  height: 100%;
  position:relative;
  overflow: hidden;
  /* background-image: url(../../public/images/bgs/1.jpeg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  background-position-y: 50%;
}
.wrap .editHead{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 55px;
  display: flex;
  font-family: Open Sans,sans-serif;
  line-height: 54px;
  color: #ccc;
  background: #333;
  border-bottom: 1px solid #000;
  align-items: center;
}
svg{
  width:25px;
  height:25px;
}
.wrap .editHead .logo{
    display: inline-block;
    width: 35px;
    height: 20px;
    margin-right: 15px;
    margin-left: 10px;
    line-height: normal;
    display: block;
    background: url(../../public/imgs/common/logo1.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}
.wrap .editHead .modelname{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
}
.wrap .editHead .actions{
    margin-right: 10px;
    flex: auto 0;
    display: flex;
    align-items: center;
    height:55px;
}
.editHead .el-divider--vertical {
    height: 50%;
    background-color: gray;
}
.el-button{
  font-weight:bold !important;
  font-size:16px;
}
.material .modelSelectWrap,.material .matStyleWrap{
  position:relative;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  font-weight:lighter;
  font-size:14px;
  text-indent: 5px;
  line-height: 30px;
}
.material .modelSelectWrap .label,.material .matStyleWrap .label{
  position:relative;
  width:100%;
  text-align: left;
  color:#fff;
}
.material .modelSelectWrap .selectUp,.material .matStyleWrap .selectUp{
  width:280px;
  height:30px;
  background-color: #333;
  border: 1px solid #333;
  border-radius: 4px 4px;
  position:relative;
  box-sizing: border-box;
  text-align: left;
}
.material .modelSelectWrap .selectUp:hover,.material .matStyleWrap .selectUp:hover{
  background-color: #111;
}
.material .modelSelectWrap .selectUp i,.material .matStyleWrap .selectUp i{
  position:absolute;
  right:5px;
  top:5px;
}
.material .modelSelectWrap .selectDown,.material .matStyleWrap .selectDown{
  width:280px;
  background-color: #333;
  position:relative;

}
.material .modelSelectWrap .selectDown .option,.material .matStyleWrap .selectDown .option{
  width:280px;
  height:30px;
  line-height: 30px;
  background-color: #333;
  color:#fff;
  text-align: left;
}
.material .modelSelectWrap .selectDown .option.active,.material .matStyleWrap .selectDown .option.active{
  width:280px;
  height:30px;
  line-height: 30px;
  background-color: #666;
}
.material .item{
  clear: both;
  overflow:hidden;
  position: relative;
  padding-bottom: 0;
}
.material .item .label{
  height:40px;
  line-height: 40px;
  vertical-align: middle;
  position: absolute;
  color:#fff;
}
.material .item .el-color-picker{
  display: inline-block;
  margin-left: 80px;
}
.material .item .el-color-picker .el-color-picker__icon{
  display: none!important;
}
.material .item .el-input{
  margin-left: 80px;
  margin-top: 6px;
}
.material .mapstate{
  margin-left: 200px;
}
.material .item .avatar-uploader{
  display: inline-block;
  margin-left: 80px;
  background-color: white;
  width:120px;
  height:40px;
  overflow: hidden;
  position:relative;
}
.material .item .avatar{
  width:120px;
  position:absolute;
  top:50%;
  transform: translateY(-50%);
}
.avatar-uploader-icon{
  font-size: 28px;
  color: #8c939d;
  width:120px;
  height:40px;
  line-height: 40px;
  text-align: center;
}
.material .item .selectWrap{
  position:relative;
  text-align: center;
  font-weight:lighter;
  font-size:12px;
  text-indent: 5px;
  line-height: 30px;
  margin-left: 80px;
  margin-top: 7px;
}
.material .item .selectWrap .label{
  position:relative;
  width:100%;
  text-align: left;
  color:#fff;
}
.material .item .selectWrap .selectUp{
  width:220px;
  height:30px;
  background-color: #333;
  border: 1px solid #333;
  border-radius: 4px 4px;
  position:relative;
  box-sizing: border-box;
  text-align: left;
  color:#fff;
}
.material .item .selectWrap .selectUp:hover{
  background-color: #111;
}
.material .item .selectWrap .selectUp i{
  position:absolute;
  right:5px;
  top:7px;
}
.material .item .selectWrap .selectDown{
  width:220px;
  background-color: #333;
  position:relative;
  color:#fff;
}
.material .item .selectWrap .selectDown .option{
  width:220px;
  height:30px;
  line-height: 30px;
  background-color: #333;
  color:#fff;
  text-align: left;
}
.material .item .selectWrap .selectDown .option.active{
  width:220px;
  height:30px;
  line-height: 30px;
  background-color: #666;
}
.material .el-collapse-item__header{
  position: relative;
}
.material .state{
  position:absolute;
  right:5px;
}
.material .el-collapse-item{
  position: relative;
}
.material .el-collapse{
  padding-bottom: 100px; 
  border: none;
}
.material .item .stateWrap{
  width:240px;
  height:40px;
  position:relative;
  color:#fff;
  margin-left: 80px;
}
.material .item .stateWrap .state{
  top:8px;
  right:190px;
}
.material .modelSelectWrap .item{
  padding-bottom: 0;
}
.material .modelSelectWrap .item .label{
  left:0;
}
.material .modelSelectWrap .item .stateWrap{
  margin-left: 120px;
}
.material .modelSelectWrap .item .stateWrap .on{
  text-align: left;
}
.postprocessing .el-collapse-item__header{
  position: relative;
}
.postprocessing .state{
  position:absolute;
  right:5px;
}
.postprocessing .el-collapse-item{
  position: relative;
}
.hotpoint{

}
.hotpoint .box-card{
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #333;
  box-sizing: border-box;
  overflow: hidden;
}
.hotpoint  .hotpointsWrap{
  height:200px;
}
.hotpoint .hotPointItem{
  color:#fff;
  width:100%;
  height:30px;
  cursor: pointer;
  font-size: 14px;
}
.hotpoint .hotPointItem.active{
  background: #595959;
}
.hotpoint .hotPointItem span{
  display: inline-block;
  height:30px !important;
  line-height: 30px;
}
.hotpoint .hotPointItem .num{
  width:10% !important;
}
.hotpoint .hotPointItem .name{
  width:70% !important;
}
.hotpoint .hotPointItem i{
  width:10% !important;
}
.hotpoint .lightProWrap{
  background-color: #595959;
}
.hotpoint .clearfix span{
  color:#ccc;
  font-size:13px;
  line-height:30px;
}
.hotpoint .hotInfosWrap{
  background-color:#595959;
}
.hotpoint .hotInfosWrap .el-card__body{
  padding: 20px 5px 20px 5px;
}
.hotpoint .item .selectWrap {
  position:relative;
  text-align: center;
  font-weight:lighter;
  font-size:13px;
  text-indent: 5px;
  line-height: 30px;
  margin-left: 80px;
  margin-top: 7px;
}
.hotpoint .item .selectWrap .selectUp {
  width:190px;
  height:30px;
  background-color: #333;
  border: 1px solid #333;
  border-radius: 4px 4px;
  position:relative;
  box-sizing: border-box;
  text-align: left;
  color:#fff;
  text-indent: 15px;
}
.hotpoint .item .selectWrap .selectUp i {
  position:absolute;
  right:5px;
  top:7px;
}
.hotpoint .item .selectWrap .selectDown{
  width:190px;
  background-color: #333;
  position:relative;
  color:#fff;
}
.hotpoint .item .selectWrap .selectDown .option{
  width:190px;
  height:30px;
  line-height: 30px;
  background-color: #333;
  color:#fff;
  text-align: left;
  text-indent: 15px;
}
.hotpoint .item .selectWrap .selectDown .option.active{
  width:190px;
  height:30px;
  line-height: 30px;
  background-color: #666;
}
.hotpoint .item{
  clear: both;
  overflow: hidden;
  position: relative;
  padding-bottom: 0;
  font-size:13px;
}
.hotpoint .item .label {
  height:40px;
  line-height: 40px;
  vertical-align: middle;
  position: absolute;
  color:#fff;
}
.hotpoint .item .el-input {
  margin-left: 80px;
  margin-top: 6px;
  width: 190px;
}
.hotpoint .item .el-textarea{
  margin-left: 80px;
  margin-top: 6px;
  width: 190px;
  font-family: "微软雅黑";
}
.hotpoint .item .avatar-uploader{
  display: inline-block;
  margin-left: 80px;
  background-color: white;
  width:120px;
  height:40px;
  overflow: hidden;
  position:relative;
}
.hotpoint .item .avatar{
  width:120px;
  position:absolute;
  top:50%;
  transform: translateY(-50%);
}
.hotpoint .item .uploadBtn{
  position:absolute;
  top:50px;
  font-size: 30px;
}
.hotpoint .tip .item{
  color:#ccc;
  padding: 5px;
  font-size:16px;
}
.hotpoint .tip .item i{
  margin-right:5px;
}
.others .el-collapse-item__header{
  position: relative;
}
.others .state{
  position:absolute;
  right:5px;
}
.others .el-collapse-item{
  position: relative;
}
.others .item{
  clear: both;
  overflow: hidden;
  position: relative;
  padding-bottom: 0;
  font-size:13px;
  color:#fff;
}
.others .clearfix span{
  color:#ccc;
  font-size:14px;
  line-height:30px;
  margin-left: 10px;
}
.others .clearfix i{
  color:#fff;
  font-size:14px;
  line-height:30px;
  margin-left: 10px;
  cursor: pointer;
  position: absolute;
  right:20px;
}
.others .item .label {
  height:40px;
  line-height: 40px;
  vertical-align: middle;
  position: absolute;
}
.others .item .el-input {
  margin-left: 80px;
  margin-top: 6px;
  width: 190px;
}
.others .item .el-textarea{
  margin-left: 80px;
  margin-top: 6px;
  width: 190px;
  font-family: "微软雅黑";
}
.others .item .avatar-uploader{
  display: inline-block;
  margin-left: 80px;
  background-color: white;
  width:120px;
  height:40px;
  overflow: hidden;
  position:relative;
}
.others .item .avatar{
  width:120px;
  position:absolute;
  top:50%;
  transform: translateY(-50%);
}
.others .item .uploadBtn{
  position:absolute;
  top:50px;
  font-size: 30px;
}
.others .item .addBgmBtn{
  width:200px;
  margin-left: 20px;
}
.others .box-card{
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  background-color:#595959;
  box-sizing: border-box;
  overflow: hidden;
}
.others .el-card__body{
  padding: 20px 5px 20px 5px;
}
.others .item .stateWrap{
  width:240px;
  height:40px;
  position:relative;
  color:#fff;
  margin-left: 80px;
}
.others .item .stateWrap .state{
  top:8px;
  right:90px;
}
.others audio{
  width:100%;
  outline:none;
  border-radius:none ;
}
.others .item i{
  font-size:24px;
  cursor:pointer;
}
.others .item .el-icon-video-play{
  
}
.others .item .el-icon-video-pause{
} 
.others .item img{
  /* position: absolute; */
  width: 100%;
  /* left:50%;
  transform: translateX(-50%); */
}
.others .el-slider{
  position:absolute;
  width: 180px;
  left:60px;
  top:2px;
}
.others .item .selectWrap{
  position:relative;
  text-align: center;
  font-weight:lighter;
  font-size:12px;
  text-indent: 5px;
  line-height: 30px;
  margin-left: 80px;
  margin-top: 7px;
}
.others .item .selectWrap .label{
  position:relative;
  width:100%;
  text-align: left;
  color:#fff;
}
.others .item .selectWrap .selectUp{
  width:190px;
  height:30px;
  background-color: #333;
  border: 1px solid #333;
  border-radius: 4px 4px;
  position:relative;
  box-sizing: border-box;
  text-align: left;
  color:#fff;
}
.others .item .selectWrap .selectUp:hover{
  background-color: #111;
}
.others .item .selectWrap .selectUp i{
  position:absolute;
  right:5px;
  top:7px;
}
.others .item .selectWrap .selectDown{
  width:190px;
  background-color: #333;
  position:relative;
  color:#fff;
}
.others .item .selectWrap .selectDown .option{
  width:190px;
  height:30px;
  line-height: 30px;
  background-color: #333;
  color:#fff;
  text-align: left;
}
.others .item .selectWrap .selectDown .option.active{
  width:190px;
  height:30px;
  line-height: 30px;
  background-color: #666;
}
.editView .logo{
  position: absolute;
  z-index:999;
}
</style>
